/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
};

export type ActionRequiredAdmissionSupportsError = AnonymousAccountError;

export type ActionRequiredAdmissionSupportsPayload = {
  __typename?: 'ActionRequiredAdmissionSupportsPayload';
  errors: Array<ActionRequiredAdmissionSupportsError>;
  result: Maybe<ActionRequiredAdmissionSupportsResult>;
};

export type ActionRequiredAdmissionSupportsResult = {
  __typename?: 'ActionRequiredAdmissionSupportsResult';
  /** 新しい入院支援が先頭になる順で返す */
  admissionSupports: Array<AdmissionSupport>;
};

/** 患者向けに提示する入院支援。 */
export type AdmissionSupport = {
  __typename?: 'AdmissionSupport';
  /** 入院予定日時。電子カルテ連携で取得できていなければ null */
  expectedAdmittedAt: Maybe<Scalars['DateTime']>;
  facility: Facility;
  id: Scalars['ID'];
  /** 入院前問診。入院支援の作成時に必ず同時に作られるため non-null */
  preAdmissionInquiry: PreAdmissionInquiry;
  /**
   * 入院前の動画配信。1 入院支援につき 1 件で、配信していない場合は null。
   * 配信内の動画は配信時に決まった順で返す
   */
  preAdmissionVideo: Maybe<PreAdmissionVideo>;
};

export type AdmissionSupportError = AdmissionSupportNotFoundError | AnonymousAccountError;

export type AdmissionSupportNotFoundError = Error & {
  __typename?: 'AdmissionSupportNotFoundError';
  message: Scalars['String'];
};

export type AdmissionSupportPayload = {
  __typename?: 'AdmissionSupportPayload';
  errors: Array<AdmissionSupportError>;
  result: Maybe<AdmissionSupportResult>;
};

export type AdmissionSupportResult = {
  __typename?: 'AdmissionSupportResult';
  admissionSupport: AdmissionSupport;
};

export type Ampm =
  | 'AM'
  | 'PM';

export type AnonymousAccountError = Error & {
  __typename?: 'AnonymousAccountError';
  message: Scalars['String'];
};

export type AnswerPreAdmissionInquiryError = AnonymousAccountError | ConsentNotGivenError | MedicalInstitutionNotLinkedError | PatientIdNotLinkedError | PreAdmissionInquiryAlreadyCompletedError | PreAdmissionInquiryNotFoundError;

export type AnswerPreAdmissionInquiryInput = {
  answer: AskmanAnswerInput;
  personId: Scalars['ID'];
  preAdmissionInquiryId: Scalars['ID'];
  sessionQuestionId: Scalars['ID'];
};

export type AnswerPreAdmissionInquiryPayload = {
  __typename?: 'AnswerPreAdmissionInquiryPayload';
  errors: Array<AnswerPreAdmissionInquiryError>;
  result: Maybe<AnswerPreAdmissionInquiryResult>;
};

export type AnswerPreAdmissionInquiryResult = {
  __typename?: 'AnswerPreAdmissionInquiryResult';
  askmanSessionId: Scalars['ID'];
  /** 次の質問。全問回答済みの場合は null */
  nextSessionQuestion: Maybe<AskmanSessionQuestion>;
  progress: AskmanSessionProgress;
};

export type AskmanAnswerInput = {
  composite?: InputMaybe<AskmanCompositeAnswerInput>;
  date?: InputMaybe<AskmanDateAnswerInput>;
  freeText?: InputMaybe<AskmanFreeTextAnswerInput>;
  image?: InputMaybe<AskmanImageAnswerInput>;
  multipleChoice?: InputMaybe<AskmanMultipleChoiceAnswerInput>;
  number?: InputMaybe<AskmanNumberAnswerInput>;
  singleChoice?: InputMaybe<AskmanSingleChoiceAnswerInput>;
  type: AskmanAnswerType;
  yesNo?: InputMaybe<AskmanYesNoAnswerInput>;
};

export type AskmanAnswerType =
  | 'COMPOSITE'
  | 'DATE'
  | 'FREE_TEXT'
  | 'IMAGE'
  | 'MULTIPLE_CHOICE'
  | 'NUMBER'
  | 'SINGLE_CHOICE'
  | 'SKIPPED'
  | 'YES_NO';

/** askman の回答 union。9 タイプ。 */
export type AskmanAnswerVariant = AskmanCompositeAnswer | AskmanDateAnswer | AskmanFreeTextAnswer | AskmanImageAnswer | AskmanMultipleChoiceAnswer | AskmanNumberAnswer | AskmanSingleChoiceAnswer | AskmanSkippedAnswer | AskmanYesNoAnswer;

export type AskmanCompositeAnswer = {
  __typename?: 'AskmanCompositeAnswer';
  values: Array<AskmanCompositeAnswerEntry>;
};

/** COMPOSITE 回答の各フィールドの値。stringValue / numberValue のどちらかが非 null になる。 */
export type AskmanCompositeAnswerEntry = {
  __typename?: 'AskmanCompositeAnswerEntry';
  fieldUid: Scalars['String'];
  numberValue: Maybe<Scalars['Float']>;
  stringValue: Maybe<Scalars['String']>;
};

export type AskmanCompositeAnswerEntryInput = {
  fieldUid: Scalars['String'];
  numberValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type AskmanCompositeAnswerInput = {
  values: Array<AskmanCompositeAnswerEntryInput>;
};

export type AskmanCompositeDateField = AskmanCompositeField & {
  __typename?: 'AskmanCompositeDateField';
  label: Scalars['String'];
  required: Scalars['Boolean'];
  uid: Scalars['String'];
};

/** COMPOSITE 質問のフィールド（TEXT / NUMBER / DATE / SINGLE_CHOICE の 4 種） */
export type AskmanCompositeField = {
  label: Scalars['String'];
  required: Scalars['Boolean'];
  uid: Scalars['String'];
};

export type AskmanCompositeFieldDisplayAs =
  | 'PULLDOWN'
  | 'RADIO';

export type AskmanCompositeFieldVariant = AskmanCompositeDateField | AskmanCompositeNumberField | AskmanCompositeSingleChoiceField | AskmanCompositeTextField;

export type AskmanCompositeNumberField = AskmanCompositeField & {
  __typename?: 'AskmanCompositeNumberField';
  decimalPlaces: Scalars['Int'];
  defaultValue: Maybe<Scalars['Float']>;
  label: Scalars['String'];
  max: Scalars['Float'];
  min: Scalars['Float'];
  required: Scalars['Boolean'];
  uid: Scalars['String'];
  unit: Maybe<Scalars['String']>;
};

export type AskmanCompositeQuestion = AskmanQuestion & {
  __typename?: 'AskmanCompositeQuestion';
  fields: Array<AskmanCompositeFieldVariant>;
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AskmanCompositeSingleChoiceField = AskmanCompositeField & {
  __typename?: 'AskmanCompositeSingleChoiceField';
  displayAs: AskmanCompositeFieldDisplayAs;
  label: Scalars['String'];
  options: Array<AskmanQuestionOption>;
  required: Scalars['Boolean'];
  uid: Scalars['String'];
};

export type AskmanCompositeTextField = AskmanCompositeField & {
  __typename?: 'AskmanCompositeTextField';
  /** UI 初期表示のデフォルト値 */
  defaultValue: Maybe<Scalars['String']>;
  isMultiline: Scalars['Boolean'];
  keyboardType: AskmanFreeTextKeyboardType;
  label: Scalars['String'];
  maxLength: Maybe<Scalars['Int']>;
  placeholder: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  uid: Scalars['String'];
};

export type AskmanDateAnswer = {
  __typename?: 'AskmanDateAnswer';
  /** YYYY-MM-DD */
  date: Scalars['String'];
};

export type AskmanDateAnswerInput = {
  /** YYYY-MM-DD */
  date: Scalars['String'];
};

export type AskmanDateQuestion = AskmanQuestion & {
  __typename?: 'AskmanDateQuestion';
  /** フォーム初期表示日付（YYYY-MM-DD） */
  defaultDate: Maybe<Scalars['String']>;
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  /** 選択可能な最大日付（YYYY-MM-DD） */
  maxDate: Maybe<Scalars['String']>;
  /** 選択可能な最小日付（YYYY-MM-DD） */
  minDate: Maybe<Scalars['String']>;
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AskmanFreeTextAnswer = {
  __typename?: 'AskmanFreeTextAnswer';
  body: Scalars['String'];
};

export type AskmanFreeTextAnswerInput = {
  body: Scalars['String'];
};

export type AskmanFreeTextKeyboardType =
  | 'DEFAULT'
  | 'EMAIL'
  | 'TEL'
  | 'URL';

export type AskmanFreeTextQuestion = AskmanQuestion & {
  __typename?: 'AskmanFreeTextQuestion';
  hint: Maybe<Scalars['String']>;
  isMultiline: Scalars['Boolean'];
  isSkippable: Scalars['Boolean'];
  keyboardType: AskmanFreeTextKeyboardType;
  maxLength: Maybe<Scalars['Int']>;
  placeholder: Maybe<Scalars['String']>;
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AskmanGuidanceSection = {
  __typename?: 'AskmanGuidanceSection';
  items: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type AskmanImageAnswer = {
  __typename?: 'AskmanImageAnswer';
  fileIds: Array<Scalars['ID']>;
  /** 画像ダウンロード用 signed URL。問診結果表示時に取得する。通常の回答取得では null。 */
  images: Maybe<Array<AskmanImageDownload>>;
};

export type AskmanImageAnswerInput = {
  fileIds: Array<Scalars['ID']>;
};

export type AskmanImageDownload = {
  __typename?: 'AskmanImageDownload';
  downloadUrl: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileId: Scalars['ID'];
  mimeType: Scalars['String'];
  originalFilename: Scalars['String'];
};

export type AskmanImageMimeType =
  | 'HEIC'
  | 'HEIF'
  | 'JPEG'
  | 'PNG'
  | 'WEBP';

export type AskmanImageQuestion = AskmanQuestion & {
  __typename?: 'AskmanImageQuestion';
  allowedMimeTypes: Array<AskmanImageMimeType>;
  guidanceSections: Array<AskmanGuidanceSection>;
  hint: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  maxFileSizeBytes: Scalars['Int'];
  maxImageCount: Scalars['Int'];
  minImageCount: Scalars['Int'];
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AskmanMultipleChoiceAnswer = {
  __typename?: 'AskmanMultipleChoiceAnswer';
  selectedOptionUids: Array<Scalars['String']>;
};

export type AskmanMultipleChoiceAnswerInput = {
  selectedOptionUids: Array<Scalars['String']>;
};

export type AskmanMultipleChoiceQuestion = AskmanQuestion & {
  __typename?: 'AskmanMultipleChoiceQuestion';
  /** null の場合は空選択不可。非 null のときは「該当なし」ボタンがこの文言で表示される。 */
  emptyChoiceLabel: Maybe<Scalars['String']>;
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  options: Array<AskmanQuestionOption>;
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AskmanNumberAnswer = {
  __typename?: 'AskmanNumberAnswer';
  value: Scalars['Float'];
};

export type AskmanNumberAnswerInput = {
  value: Scalars['Float'];
};

export type AskmanNumberQuestion = AskmanQuestion & {
  __typename?: 'AskmanNumberQuestion';
  decimalPlaces: Scalars['Int'];
  defaultValue: Maybe<Scalars['Float']>;
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  max: Scalars['Float'];
  min: Scalars['Float'];
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
  unit: Maybe<Scalars['String']>;
};

/**
 * askman の質問。タイプごとに固有フィールドを持つ。
 * 共通フィールド（uid, text, hint, isSkippable, resultDisplayLabel）は AskmanQuestion インターフェース経由で取得できる。
 */
export type AskmanQuestion = {
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

/** 選択肢（SINGLE_CHOICE / MULTIPLE_CHOICE / COMPOSITE の SINGLE_CHOICE フィールドで共通利用） */
export type AskmanQuestionOption = {
  __typename?: 'AskmanQuestionOption';
  label: Scalars['String'];
  resultDisplayLabel: Maybe<Scalars['String']>;
  uid: Scalars['String'];
};

/** askman の質問 union。AskmanQuestion インターフェースを実装する 8 タイプ。 */
export type AskmanQuestionVariant = AskmanCompositeQuestion | AskmanDateQuestion | AskmanFreeTextQuestion | AskmanImageQuestion | AskmanMultipleChoiceQuestion | AskmanNumberQuestion | AskmanSingleChoiceQuestion | AskmanYesNoQuestion;

/** askman の問診進捗情報。フェーズ数と現在のフェーズ番号・ラベルを持つ。 */
export type AskmanSessionProgress = {
  __typename?: 'AskmanSessionProgress';
  currentPhaseLabel: Scalars['String'];
  /** 現在のフェーズ番号（1-indexed） */
  currentPhaseNumber: Scalars['Int'];
  totalPhaseCount: Scalars['Int'];
};

/** 問診セッション中の質問インスタンス。対象の質問内容と（あれば）回答を保持する。 */
export type AskmanSessionQuestion = {
  __typename?: 'AskmanSessionQuestion';
  answer: Maybe<AskmanAnswerVariant>;
  id: Scalars['ID'];
  question: AskmanQuestionVariant;
  questionNumber: Scalars['Int'];
  questionRuleId: Scalars['String'];
  questionUid: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type AskmanSingleChoiceAnswer = {
  __typename?: 'AskmanSingleChoiceAnswer';
  selectedOptionUid: Scalars['String'];
};

export type AskmanSingleChoiceAnswerInput = {
  selectedOptionUid: Scalars['String'];
};

export type AskmanSingleChoiceQuestion = AskmanQuestion & {
  __typename?: 'AskmanSingleChoiceQuestion';
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  options: Array<AskmanQuestionOption>;
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

/** スキップされた回答 */
export type AskmanSkippedAnswer = {
  __typename?: 'AskmanSkippedAnswer';
  /** スキップであることを示すフラグ（常に true） */
  skipped: Scalars['Boolean'];
};

export type AskmanYesNoAnswer = {
  __typename?: 'AskmanYesNoAnswer';
  isYes: Scalars['Boolean'];
};

export type AskmanYesNoAnswerInput = {
  isYes: Scalars['Boolean'];
};

export type AskmanYesNoQuestion = AskmanQuestion & {
  __typename?: 'AskmanYesNoQuestion';
  hint: Maybe<Scalars['String']>;
  isSkippable: Scalars['Boolean'];
  resultDisplayLabel: Scalars['String'];
  text: Scalars['String'];
  uid: Scalars['String'];
};

export type AvailableLinkMedicalInstitution = {
  __typename?: 'AvailableLinkMedicalInstitution';
  facility: LinkedFacility;
  feature: LinkedMedicalInstitutionFeature;
  linkCode: Scalars['String'];
  linkCodeId: Scalars['ID'];
  medicalInstitution: LinkedMedicalInstitutionInfo;
};

export type BirthdayInput = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type BookPharmacyError = PharmacyBookingConsentUnavailableError | PharmacyBookingInvalidPersonalInformationError | PharmacyBookingInvalidTimeSlotError | PharmacyBookingInvalidVerificationTokenError | PharmacyBookingPartnerBookingFailedError | PharmacyBookingPartnerCancelFailedError | PharmacyBookingPharmacyNotFoundError | PharmacyBookingPrescriptionImageLimitExceededError | PharmacyBookingPrescriptionImageNotFoundError | PharmacyBookingPrescriptionImageRequiredError | PharmacyBookingPrescriptionImageUnavailableError | PharmacyBookingUnexpectedError | PharmacyBookingVerificationTokenAlreadyUsedError;

export type BookPharmacyInput = {
  personId: Scalars['ID'];
  personalInformation: BookPharmacyPersonalInformationInput;
  /** 薬局識別子 */
  pharmacyId: Scalars['ID'];
  /** アップロード済み処方箋画像 ID 一覧（1 枚以上・5 枚以下） */
  prescriptionImageIds: Array<Scalars['ID']>;
  questionnaire: BookPharmacyQuestionnaireInput;
  /** 受け取り希望枠の開始日時（JST 30 分境界） */
  timeSlotStartsAt: Scalars['DateTime'];
  /** メール確認トークン（verifyPharmacyBookingEmailOtp で取得） */
  verificationToken: Scalars['String'];
};

export type BookPharmacyPayload = {
  __typename?: 'BookPharmacyPayload';
  /** 予約 ID */
  bookingId: Maybe<Scalars['ID']>;
  errors: Array<BookPharmacyError>;
  /** 管理トークン平文（完了画面の管理 URL 用。一度だけ返却） */
  managementToken: Maybe<Scalars['String']>;
};

export type BookPharmacyPersonalInformationInput = {
  /** 年齢（満年齢） */
  age: Scalars['Int'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  /** 電話番号 */
  phoneNumber: Scalars['String'];
  /** 体重（kg）。15 歳未満は必須 */
  weightKg?: InputMaybe<Scalars['Float']>;
};

export type BookPharmacyQuestionnaireInput = {
  brandNameDrugPreference: PharmacyBookingBrandNameDrugPreference;
  medicationNotebookIntention: PharmacyBookingMedicationNotebookIntention;
  pickupRecipientType: PharmacyBookingPickupRecipientType;
};

export type CancelAllMedicalInstitutionFeatureConsentPayload = {
  __typename?: 'CancelAllMedicalInstitutionFeatureConsentPayload';
  success: Scalars['Boolean'];
};

export type CancelPharmacyBookingError = PharmacyBookingInvalidManagementTokenError | PharmacyBookingManagementTokenExpiredError | PharmacyBookingNotCancellableError | PharmacyBookingPartnerCancelFailedError | PharmacyBookingUnexpectedError;

export type CancelPharmacyBookingInput = {
  /** 管理トークン平文（管理 URL のパスから取得） */
  managementToken: Scalars['String'];
};

export type CancelPharmacyBookingPayload = {
  __typename?: 'CancelPharmacyBookingPayload';
  bookingId: Maybe<Scalars['ID']>;
  errors: Array<CancelPharmacyBookingError>;
};

/** チェックイン（院内 QR スキャンによる来院記録） */
export type CheckIn = {
  __typename?: 'CheckIn';
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * 当該病院での初診かどうか。
   * 判定ソース: check_ins.visit_memo_received_at（受診メモ受信日時）が null でない当日(JST)より前の記録の有無。
   * sendVisitMemo は consultation_summaries 作成と check_ins.visit_memo_received_at セットを同時に行うため、
   * 受診メモの有無と等価。過去の受診メモ付き check_in が無ければ true（初診）、あれば false（再診）。
   * 同一カレンダー日(JST)の check_in はカウントしない。
   */
  isFirstVisit: Scalars['Boolean'];
};

/** チェックインに書き込まれた基本情報6項目（氏名・カナ・性別・生年月日）。 */
export type CheckInBasicInfo = {
  __typename?: 'CheckInBasicInfo';
  birthday: Scalars['DateTime'];
  nameFirst: Scalars['String'];
  nameFirstKana: Scalars['String'];
  nameLast: Scalars['String'];
  nameLastKana: Scalars['String'];
  sex: Sex;
};

/** 当日(JST)・未完了のチェックインが無い（先にチェックインが必要）。 */
export type CheckInNotFoundError = Error & {
  __typename?: 'CheckInNotFoundError';
  message: Scalars['String'];
};

/** 6桁コード分岐画面が入るべき導線。 */
export type CheckInRoute =
  /** GPチェックイン導線（provisional-linkage）。同意・本人情報入力の後、チェックインを作成する。 */
  | 'GP_CHECKIN'
  /** 病院連携導線。チェックインは作らない（現状どおり）。 */
  | 'HOSPITAL_LINKAGE';

/** 6桁コード分岐画面向けの導線判定結果。 */
export type CheckInRouteDecision = {
  __typename?: 'CheckInRouteDecision';
  /**
   * 導線に入った後、同意画面と本人情報入力をスキップしてよい2回目以降の来院として扱うか。
   * 同一 person × facility の check_ins が1件以上あり、かつ GP チェックイン機能が有効なときだけ true。
   * 未ログイン（匿名アカウント）は履歴を評価できないため常に false（初回扱い）。
   */
  isRepeatVisit: Scalars['Boolean'];
  /** 入るべき導線。医療機関設定（linkedCompleteScreen）だけで決まる。チェックイン履歴は含まない。 */
  route: CheckInRoute;
};

export type ClinicalDepartment = {
  __typename?: 'ClinicalDepartment';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CompletePreAdmissionInquiryError = AnonymousAccountError | ConsentNotGivenError | MedicalInstitutionNotLinkedError | PatientIdNotLinkedError | PreAdmissionInquiryNotFoundError;

export type CompletePreAdmissionInquiryInput = {
  personId: Scalars['ID'];
  preAdmissionInquiryId: Scalars['ID'];
};

export type CompletePreAdmissionInquiryPayload = {
  __typename?: 'CompletePreAdmissionInquiryPayload';
  errors: Array<CompletePreAdmissionInquiryError>;
  result: Maybe<CompletePreAdmissionInquiryResult>;
};

export type CompletePreAdmissionInquiryResult = {
  __typename?: 'CompletePreAdmissionInquiryResult';
  preAdmissionInquiryId: Scalars['ID'];
  status: PreAdmissionInquiryStatus;
};

export type CompletePreAdmissionVideoPdfViewingInput = {
  /** 配信元の医療機関 ID。患者を一意に特定するために必須 */
  facilityId: Scalars['Int'];
  /** 配信内の動画 1 件の ID。PDF は動画に付随するため動画と同じ ID で指定する */
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  /** 入院前の動画配信 ID（配信単位） */
  preAdmissionVideoId: Scalars['ID'];
};

export type CompletePreAdmissionVideoPdfViewingPayload = {
  __typename?: 'CompletePreAdmissionVideoPdfViewingPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<CompletePreAdmissionVideoPdfViewingResult>;
};

export type CompletePreAdmissionVideoPdfViewingResult = {
  __typename?: 'CompletePreAdmissionVideoPdfViewingResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type CompletePreAdmissionVideoViewingInput = {
  /** 配信元の医療機関 ID。患者を一意に特定するために必須 */
  facilityId: Scalars['Int'];
  /** 配信内の動画 1 件の ID */
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  /** 入院前の動画配信 ID（配信単位） */
  preAdmissionVideoId: Scalars['ID'];
};

export type CompletePreAdmissionVideoViewingPayload = {
  __typename?: 'CompletePreAdmissionVideoViewingPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<CompletePreAdmissionVideoViewingResult>;
};

export type CompletePreAdmissionVideoViewingResult = {
  __typename?: 'CompletePreAdmissionVideoViewingResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type Consent = {
  __typename?: 'Consent';
  acceptDisclosure: Scalars['Boolean'];
  consentId: Scalars['ID'];
};

export type ConsentItem = {
  __typename?: 'ConsentItem';
  consent: Maybe<Consent>;
  disclosure: Disclosure;
};

export type ConsentNotGivenError = Error & {
  __typename?: 'ConsentNotGivenError';
  message: Scalars['String'];
  /** 未同意の同意項目一覧 */
  requiredConsents: Array<ConsentItem>;
};

/** 患者アプリ向けの会話共有リクエスト（表示に必要な最小情報）。 */
export type ConversationShareRequestForConsumer = {
  __typename?: 'ConversationShareRequestForConsumer';
  /** やりとりサマリ（カードの見出し。= MIS phr_escalations.exchange_summary） */
  exchangeSummary: Maybe<Scalars['String']>;
  /** 事象発生時刻（PHR 側） */
  occurredAt: Scalars['DateTime'];
  /** 対象エスカレーション通知の連携元ID（= coedo.phr_escalations.id）。会話セッションへの解決キー。 */
  rawRecordId: Scalars['ID'];
  /** 医師がリクエストした日時 */
  requestedAt: Scalars['DateTime'];
  /** リクエスト状態 */
  status: ConversationShareRequestStatus;
};

/** 会話共有リクエストの状態 */
export type ConversationShareRequestStatus =
  | 'APPROVED'
  | 'DECLINED'
  | 'PENDING';

export type ConversationShareRequestsInput = {
  /** 対象医療機関ID */
  facilityId: Scalars['Int'];
  /** 対象の生活者（Person ID / Medico ユーザID） */
  personId: Scalars['ID'];
};

/** チェックイン作成の入力 */
export type CreateCheckInInput = {
  /** 生年月日（時刻部分は無視される。Date スカラー未定義のため DateTime で受ける） */
  birthday: Scalars['DateTime'];
  /** 医療機関 ID（病院連携サブルーチンで解決済みの facility_id） */
  facilityId: Scalars['Int'];
  /** 名 */
  nameFirst: Scalars['String'];
  /** メイ（名カナ） */
  nameFirstKana: Scalars['String'];
  /**
   * 姓。
   *
   * FIXME（暫定）: 以下の基本情報（氏名・カナ・性別・生年月日）は、医師向け画面の患者名表示
   * （check_ins.name_last / name_first）を埋めるためにチェックイン時に書き込む。
   * 本来は coedo→hecate relay→medinavi-backend(internal) で受信する想定。
   * relay 実装後はこれらの基本情報フィールド（nameLast / nameFirst / nameLastKana / nameFirstKana / sex / birthday）を撤去する。
   */
  nameLast: Scalars['String'];
  /** セイ（姓カナ） */
  nameLastKana: Scalars['String'];
  /**
   * linkProvisionalId で確立済みの仮ID連携 ID。仮IDフローではこれを渡す（createCheckIn は仮ID連携を確立しない）。
   * 未指定時は本連携済みの診察券番号で紐付ける。
   */
  provisionalIdLinkageId?: InputMaybe<Scalars['ID']>;
  /** 生物学的性別（MALE: 男性 / FEMALE: 女性） */
  sex: Sex;
};

export type CreateCheckInPayload = {
  __typename?: 'CreateCheckInPayload';
  checkIn: CheckIn;
};

export type CreateMedicalInstitutionFeatureConsentPayload = {
  __typename?: 'CreateMedicalInstitutionFeatureConsentPayload';
  success: Scalars['Boolean'];
};

export type CreateRequestAppointmentConsentInput = {
  disclosureIds: Array<Scalars['ID']>;
  personId: Scalars['ID'];
};

export type CreateRequestAppointmentConsentPayload = {
  __typename?: 'CreateRequestAppointmentConsentPayload';
  success: Scalars['Boolean'];
};

export type CreateRequestAppointmentError = DuplicateRequestError;

/** リクエスト予約の作成 */
export type CreateRequestAppointmentInput = {
  appointmentType: RequestAppointmentType;
  consultation: RequestAppointmentConsultationInput;
  emailVerificationToken: Scalars['String'];
  facilityId: Scalars['Int'];
  facilityMenuId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  originalAppointmentStartAt?: InputMaybe<Scalars['DateTime']>;
  patientCard: RequestAppointmentPatientCardInput;
  personId: Scalars['ID'];
  personalInformation: RequestAppointmentPersonalInformationInput;
  referral?: InputMaybe<RequestAppointmentReferralInput>;
  requestedAppointmentDateTimeSlots: Array<RequestedAppointmentDateTimeSlotInput>;
};

export type CreateRequestAppointmentPayload = {
  __typename?: 'CreateRequestAppointmentPayload';
  errors: Array<CreateRequestAppointmentError>;
  requestAppointmentCard: Maybe<RequestAppointmentCard>;
};

export type DateWithoutTime = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'HOLIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type DebugIssueTestFacilityLinkageCodeInput = {
  facilityPatientId: Scalars['String'];
  personId: Scalars['ID'];
};

export type DebugUnlinkTestFacilityPatientIdInput = {
  personId: Scalars['ID'];
};

export type DebugUnlinkTestFacilityPatientIdPayload = {
  __typename?: 'DebugUnlinkTestFacilityPatientIdPayload';
  success: Scalars['Boolean'];
};

export type DeclineConversationShareRequestInput = {
  /** 対象医療機関ID */
  facilityId: Scalars['Int'];
  /** 対象の生活者（Person ID / Medico ユーザID） */
  personId: Scalars['ID'];
  /** 対象エスカレーション通知の連携元ID（= coedo.phr_escalations.id） */
  rawRecordId: Scalars['ID'];
};

export type DeclineConversationShareRequestPayload = {
  __typename?: 'DeclineConversationShareRequestPayload';
  success: Scalars['Boolean'];
};

export type Disclosure = {
  __typename?: 'Disclosure';
  content: Scalars['String'];
  disclosureId: Scalars['ID'];
  policyId: Scalars['ID'];
  title: Scalars['String'];
};

export type DuplicateRequestError = Error & {
  __typename?: 'DuplicateRequestError';
  existingRequestAppointmentId: Scalars['ID'];
  message: Scalars['String'];
};

export type EmailVerificationAnonymousAccountError = Error & {
  __typename?: 'EmailVerificationAnonymousAccountError';
  message: Scalars['String'];
};

export type EmailVerificationAttemptsExceededError = Error & {
  __typename?: 'EmailVerificationAttemptsExceededError';
  message: Scalars['String'];
};

export type EmailVerificationExpiredError = Error & {
  __typename?: 'EmailVerificationExpiredError';
  message: Scalars['String'];
};

export type EmailVerificationInvalidCodeError = Error & {
  __typename?: 'EmailVerificationInvalidCodeError';
  message: Scalars['String'];
};

export type EmailVerificationInvalidEmailError = Error & {
  __typename?: 'EmailVerificationInvalidEmailError';
  message: Scalars['String'];
};

export type EmailVerificationRateLimitedError = Error & {
  __typename?: 'EmailVerificationRateLimitedError';
  message: Scalars['String'];
};

/** EMR（電子カルテ）が保持する患者情報 */
export type EmrPatient = {
  __typename?: 'EmrPatient';
  /** YYYY-MM-DD 形式。未登録は null */
  dateOfBirth: Maybe<Scalars['String']>;
  /** 診察券番号（施設内患者 ID = facility_patient_id） */
  facilityPatientId: Scalars['ID'];
  name: Maybe<EmrPatientName>;
  sex: Maybe<EmrSex>;
};

export type EmrPatientName = {
  __typename?: 'EmrPatientName';
  firstName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastName: Scalars['String'];
  lastNameKana: Scalars['String'];
  middleName: Maybe<Scalars['String']>;
  middleNameKana: Maybe<Scalars['String']>;
};

/** EMR の性別表現（EMR レスポンスの SexResource 準拠） */
export type EmrSex =
  | 'FEMALE'
  | 'MALE'
  | 'NOT_APPLICABLE'
  | 'UNKNOWN';

/** エラー */
export type Error = {
  message: Scalars['String'];
};

export type ExperimentalSetting = {
  __typename?: 'ExperimentalSetting';
  closedDays: Array<Scalars['String']>;
  medicalInstitutionId: Scalars['String'];
  menus: Array<ExperimentalSettingMenu>;
  requestBooking: Scalars['Boolean'];
};

export type ExperimentalSettingFlow =
  | 'telephone'
  | 'web';

export type ExperimentalSettingMenu = {
  __typename?: 'ExperimentalSettingMenu';
  flow: ExperimentalSettingFlow;
  name: Scalars['String'];
  note: Maybe<Scalars['String']>;
};

export type Facility = {
  __typename?: 'Facility';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/**
 * GPかかりつけ医チェックイン機能の設定とチェックイン履歴。
 * LinkedMedicalInstitutionFeature.gpCheckin として公開する。
 */
export type GpCheckin = {
  __typename?: 'GpCheckin';
  checkinHistory: Array<GpCheckinHistoryItem>;
  isGpCheckinEnabled: Scalars['Boolean'];
  isLatestMemoReceived: Scalars['Boolean'];
};

/**
 * GPチェックインの受診メモ（prm_pii.consultation_summaries）の内容。
 * 受診記録詳細ページ表示用に、GpCheckinHistoryItem.consultationSummaryId で取得した id をキーに引く。
 */
export type GpCheckinConsultationSummary = {
  __typename?: 'GpCheckinConsultationSummary';
  currentSymptoms: Array<Scalars['String']>;
  id: Scalars['ID'];
  interests: Array<Scalars['String']>;
  lifestyle: Array<Scalars['String']>;
  medicationAdherence: Array<Scalars['String']>;
  medications: Array<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  other: Array<Scalars['String']>;
};

export type GpCheckinConsultationSummaryInput = {
  id: Scalars['ID'];
  personId: Scalars['ID'];
};

/** チェックイン履歴の 1 件分。checkedInAt が常に存在する（チェックインした事実）。 */
export type GpCheckinHistoryItem = {
  __typename?: 'GpCheckinHistoryItem';
  checkedInAt: Scalars['DateTime'];
  consultationSummaryId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  status: GpCheckinHistoryStatus;
  visitMemoReceivedAt: Maybe<Scalars['DateTime']>;
};

export type GpCheckinHistoryStatus =
  | 'CHECKED_IN'
  | 'QUESTIONNAIRE_SENT';

export type ImportLifestyleDiseaseSupportTherapyError = LifestyleDiseaseSupportTherapyConsentRequiredError | LifestyleDiseaseSupportTherapyNotLinkedError;

export type ImportLifestyleDiseaseSupportTherapyInput = {
  /** 今回受諾した同意の disclosureId 一覧。空配列なら同意保存をスキップする */
  disclosureIds: Array<Scalars['ID']>;
  /** ID 連携状態の解決（RLS の患者コンテキスト）に使う */
  facilityId: Scalars['Int'];
  lifestyleDiseaseSupportTherapyId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type ImportLifestyleDiseaseSupportTherapyPayload = {
  __typename?: 'ImportLifestyleDiseaseSupportTherapyPayload';
  errors: Array<ImportLifestyleDiseaseSupportTherapyError>;
  /** 取り込んだ指導サマリー。閲覧不可（不存在・取消済み）または errors がある場合は null */
  lifestyleDiseaseSupportTherapy: Maybe<LifestyleDiseaseSupportTherapy>;
};

export type IssueImageUploadUrlInput = {
  mimeType: AskmanImageMimeType;
  originalFilename: Scalars['String'];
  questionUid: Scalars['String'];
  sessionId: Scalars['ID'];
  /** ファイルサイズ（バイト） */
  size: Scalars['Int'];
};

export type IssueImageUploadUrlPayload = {
  __typename?: 'IssueImageUploadUrlPayload';
  expiresAt: Scalars['DateTime'];
  fileId: Scalars['ID'];
  /** uploadUrl に対して使用する HTTP メソッド。本番環境では "PUT"、ローカル開発（fake-gcs-server）では "POST"。 */
  httpMethod: Scalars['String'];
  /** 画像アップロード用 URL（15 分有効）。httpMethod に従ってリクエストすること。 */
  uploadUrl: Scalars['String'];
};

export type IssueOtpCodeError = EmailVerificationAnonymousAccountError | EmailVerificationInvalidEmailError | EmailVerificationRateLimitedError;

export type IssueOtpCodeInput = {
  email: Scalars['String'];
  personId: Scalars['ID'];
};

export type IssueOtpCodePayload = {
  __typename?: 'IssueOtpCodePayload';
  errors: Array<IssueOtpCodeError>;
  otpId: Maybe<Scalars['ID']>;
};

export type IssuePharmacyBookingPrescriptionImageUploadUrlError = PharmacyBookingPrescriptionImageUnsupportedTypeError | PharmacyBookingUnexpectedError;

export type IssuePharmacyBookingPrescriptionImageUploadUrlInput = {
  /** ファイルサイズ（バイト）。サイズの UX 検証はフロント側 */
  contentLength: Scalars['Int'];
  /** アップロードする画像の Content-Type。許可は image/jpeg と image/png のみ */
  contentType: Scalars['String'];
  personId: Scalars['ID'];
};

export type IssuePharmacyBookingPrescriptionImageUploadUrlPayload = {
  __typename?: 'IssuePharmacyBookingPrescriptionImageUploadUrlPayload';
  errors: Array<IssuePharmacyBookingPrescriptionImageUploadUrlError>;
  /** 処方箋画像 ID（予約登録時に使用） */
  imageId: Maybe<Scalars['ID']>;
  /** GCS への署名付きアップロード URL */
  uploadUrl: Maybe<Scalars['String']>;
};

/** 生活習慣病支援の指導サマリー（医療機関から患者へ送信された指導内容）。 */
export type LifestyleDiseaseSupportTherapy = {
  __typename?: 'LifestyleDiseaseSupportTherapy';
  /** 指導内容の作成者の職種 */
  createdByOccupation: LifestyleDiseaseSupportTherapyOccupation;
  /** 提供元の医療機関 */
  facility: Facility;
  /** 患者による初回表示日時。null = 未表示 */
  firstViewedAt: Maybe<Scalars['DateTime']>;
  /** 行動目標: 運動（自由記述）。null = 未入力 */
  goalExerciseAction: Maybe<Scalars['String']>;
  /** 行動目標: 食事（自由記述）。null = 未入力 */
  goalMealAction: Maybe<Scalars['String']>;
  /** 行動目標: その他（自由記述）。null = 未入力 */
  goalOtherAction: Maybe<Scalars['String']>;
  /** 達成目標: 次回受診までの目標体重 (kg)。null = 未入力 */
  goalWeightKg: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** PHR への取込日時。null = 未取込（画面の「未登録」バッジ判定に使う） */
  importedAt: Maybe<Scalars['DateTime']>;
  /**
   * 送信時点の患者の直近の生活記録サマリー本文のスナップショット。
   * サマリーが 1 件も無い場合は「前回のサマリーなし」の固定文言が入る。
   */
  latestPatientDailyRecordSummary: Scalars['String'];
  /** 医療機関からの提供日時 */
  sentAt: Scalars['DateTime'];
  /** 受診日（この指導がどの受診に紐づくか。YYYY-MM-DD 形式） */
  visitDate: Scalars['String'];
};

/** PHR への保存に必要な同意が未取得のため取り込めない（同意取得へ誘導する） */
export type LifestyleDiseaseSupportTherapyConsentRequiredError = Error & {
  __typename?: 'LifestyleDiseaseSupportTherapyConsentRequiredError';
  message: Scalars['String'];
};

/** 患者 ID 連携が未了または解除されているため PHR へ取り込めない（ID 連携フローへ誘導する） */
export type LifestyleDiseaseSupportTherapyNotLinkedError = Error & {
  __typename?: 'LifestyleDiseaseSupportTherapyNotLinkedError';
  message: Scalars['String'];
};

/** 指導内容の作成者の職種 */
export type LifestyleDiseaseSupportTherapyOccupation =
  /** 栄養士 */
  | 'DIETITIAN'
  /** 医師 */
  | 'DOCTOR'
  /** 管理栄養士 */
  | 'REGISTERED_DIETITIAN';

export type LinkItemForMigration = {
  adjustToken?: InputMaybe<Scalars['String']>;
  linkCode: Scalars['String'];
};

export type LinkMedicalInstitutionFaqItem = {
  __typename?: 'LinkMedicalInstitutionFaqItem';
  answer: Scalars['String'];
  category: Scalars['String'];
  question: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type LinkMedicalInstitutionForPatientIdLinkageError = AnonymousAccountError;

export type LinkMedicalInstitutionForPatientIdLinkageInput = {
  /** 今回受諾した未同意ポリシーの disclosureId 一覧。空配列なら同意保存をスキップ */
  disclosureIds: Array<Scalars['ID']>;
  facilityId: Scalars['Int'];
  isDeveloper: Scalars['Boolean'];
  personId: Scalars['ID'];
};

export type LinkMedicalInstitutionForPatientIdLinkagePayload = {
  __typename?: 'LinkMedicalInstitutionForPatientIdLinkagePayload';
  errors: Array<LinkMedicalInstitutionForPatientIdLinkageError>;
  success: Maybe<Scalars['Boolean']>;
};

export type LinkMedicalInstitutionsForMigrationInput = {
  isDeveloper: Scalars['Boolean'];
  linkItems: Array<LinkItemForMigration>;
  personId: Scalars['ID'];
};

export type LinkMedicalInstitutionsForMigrationPayload = {
  __typename?: 'LinkMedicalInstitutionsForMigrationPayload';
  success: Scalars['Boolean'];
};

export type LinkPatientIdError = AnonymousAccountError | LinkageCodeAlreadyUsedError | LinkageCodeExpiredError | LinkageCodeLockedError | LinkageCodeNotFoundError | PatientIdLinkageAlreadyExistsError | VerificationFailedError;

export type LinkPatientIdInput = {
  /** YYYY-MM-DD */
  birthday: Scalars['String'];
  /** 今回受諾した同意の disclosureId。空配列なら同意保存をスキップする */
  disclosureIds: Array<Scalars['ID']>;
  /** 開発者モードでの連携かどうか */
  isDeveloper: Scalars['Boolean'];
  linkageCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type LinkPatientIdPayload = {
  __typename?: 'LinkPatientIdPayload';
  errors: Array<LinkPatientIdError>;
  patientIdLinkage: Maybe<PatientIdLinkage>;
};

export type LinkProvisionalIdError = AnonymousAccountError;

/** 仮ID連携の入力 */
export type LinkProvisionalIdInput = {
  /** 今回受諾した未同意ポリシーの disclosureId 一覧。空配列なら同意保存をスキップ */
  disclosureIds: Array<Scalars['ID']>;
  isDeveloper: Scalars['Boolean'];
  /** 病院連携用の6桁コード */
  linkCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type LinkProvisionalIdPayload = {
  __typename?: 'LinkProvisionalIdPayload';
  /** ドメインエラー（本ID連携の linkPatientId と対称）。空配列なら成功。 */
  errors: Array<LinkProvisionalIdError>;
  /**
   * 本連携済み（id_linkages 存在）の場合の診察券番号。未連携または errors がある場合は null。
   * facilityPatientId と provisionalIdLinkage はいずれか一方のみが入る（本連携済みなら前者、未連携なら後者）。
   */
  facilityPatientId: Maybe<Scalars['String']>;
  /** 連携した医療機関情報（完了画面遷移に利用）。errors がある場合は null。 */
  linkedMedicalInstitution: Maybe<LinkedMedicalInstitution>;
  /** 未連携の場合に確立（または再利用）された仮ID連携。本連携済みまたは errors がある場合は null。 */
  provisionalIdLinkage: Maybe<ProvisionalIdLinkage>;
};

export type LinkToMedicalInstitutionInput = {
  adjustToken?: InputMaybe<Scalars['String']>;
  isDeveloper: Scalars['Boolean'];
  linkCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type LinkageCodeAlreadyUsedError = Error & {
  __typename?: 'LinkageCodeAlreadyUsedError';
  message: Scalars['String'];
};

export type LinkageCodeExpiredError = Error & {
  __typename?: 'LinkageCodeExpiredError';
  message: Scalars['String'];
};

/**
 * 試行回数上限超過により連携コードがロックされた。
 * 医療機関に新規コードの再発行を依頼するよう案内する。
 */
export type LinkageCodeLockedError = Error & {
  __typename?: 'LinkageCodeLockedError';
  message: Scalars['String'];
};

export type LinkageCodeNotFoundError = Error & {
  __typename?: 'LinkageCodeNotFoundError';
  message: Scalars['String'];
};

/** token 種別ごとの追加条件を満たさない（別の患者 ID で連携済み等） */
export type LinkageCodePatientMismatchError = Error & {
  __typename?: 'LinkageCodePatientMismatchError';
  message: Scalars['String'];
};

/** 本連携（id_linkages）が無く診察券番号を解決できない（窓口での診察券番号確認が必要）。 */
export type LinkageNotFoundError = Error & {
  __typename?: 'LinkageNotFoundError';
  message: Scalars['String'];
};

export type LinkedFacility = {
  __typename?: 'LinkedFacility';
  /** 医療機関タイプ */
  facilityType: Maybe<LinkedFacilityType>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** LinkedFacility.facilityType が取りうる値。 */
export type LinkedFacilityType =
  | 'GP'
  | 'HP';

export type LinkedMedicalInstitution = {
  __typename?: 'LinkedMedicalInstitution';
  adjustToken: Maybe<Scalars['String']>;
  facility: LinkedFacility;
  feature: LinkedMedicalInstitutionFeature;
  isDeveloper: Scalars['Boolean'];
  isMigrationData: Scalars['Boolean'];
  /**
   * この医療機関と患者 ID 連携（本連携）済みかどうか。仮 ID 連携は含まない。
   * 匿名アカウントは患者 ID 連携を持ち得ないため常に false。
   */
  isPatientIdLinked: Scalars['Boolean'];
  linkCode: Scalars['String'];
  linkCodeId: Scalars['ID'];
  linkedAt: Scalars['DateTime'];
  medicalInstitution: LinkedMedicalInstitutionInfo;
};

export type LinkedMedicalInstitutionCompleteScreen =
  | 'GENERAL_PRACTITIONER_ONBOARDING'
  | 'MEDICAL_INSTITUTION_DETAIL'
  | 'MEDICAL_INSTITUTION_TAB'
  | 'NORMAL_ONBOARDING';

export type LinkedMedicalInstitutionFeature = {
  __typename?: 'LinkedMedicalInstitutionFeature';
  gpCheckin: GpCheckin;
  hpPromptKey: Maybe<Scalars['String']>;
  /** @deprecated 病院タブは連携の有無だけで出るようになり、このフラグは参照されていない。古いモバイルアプリとの互換性のために残す */
  isAppTopTabEnable: Scalars['Boolean'];
  /** @deprecated 受診データの自動作成は backend 側で完結しており、アプリはこの値で分岐していない。古いモバイルアプリとの互換性のために残す */
  isAutoEncounterCreationEnabled: Scalars['Boolean'];
  isFaqEnable: Scalars['Boolean'];
  isIcFollowUpEnable: Maybe<Scalars['Boolean']>;
  isUpyChatEnable: Scalars['Boolean'];
  linkedCompleteScreen: LinkedMedicalInstitutionCompleteScreen;
  logoUrl: Maybe<Scalars['String']>;
  requestAppointmentEnableStatus: RequestAppointmentEnableStatusEnum;
  smartphoneMonshinPath: Maybe<Scalars['String']>;
  /** @deprecated Web版ではなくアプリ内で会話できるようになったため非推奨。古いモバイルアプリとの互換性のために残す */
  webUpyPath: Maybe<Scalars['String']>;
};

export type LinkedMedicalInstitutionInfo = {
  __typename?: 'LinkedMedicalInstitutionInfo';
  abbreviatedName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: Maybe<Scalars['String']>;
  websiteUrl: Maybe<Scalars['String']>;
};

export type LinkedMedicalInstitutionsInput = {
  personId: Scalars['ID'];
};

export type MakeAppointmentInput = {
  dateOfBirth: DateWithoutTime;
  firstName: Scalars['String'];
  firstNameKana: Scalars['String'];
  isDeveloper?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  lastNameKana: Scalars['String'];
  medicalInstitutionId: Scalars['String'];
  patientMessage: Scalars['String'];
  phoneNumber: Scalars['String'];
  requestedVisitDate: RequestedVisitDate;
  returnVisitDetail?: InputMaybe<ReturnVisitDetail>;
  sex: Sex;
  visitType: VisitType;
};

export type MakeAppointmentPayload = {
  __typename?: 'MakeAppointmentPayload';
  result: Scalars['Boolean'];
};

export type MarkLifestyleDiseaseSupportTherapyAsViewedInput = {
  /** ID 連携状態の解決（RLS の患者コンテキスト）に使う */
  facilityId: Scalars['Int'];
  lifestyleDiseaseSupportTherapyId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type MarkLifestyleDiseaseSupportTherapyAsViewedPayload = {
  __typename?: 'MarkLifestyleDiseaseSupportTherapyAsViewedPayload';
  /**
   * 現時点では具体的なエラー型は定義しない。
   * 将来ユーザーにフィードバックしたい業務エラーが必要になった際に union 型へ拡張する。
   */
  errors: Array<Error>;
  lifestyleDiseaseSupportTherapy: Maybe<LifestyleDiseaseSupportTherapy>;
};

/**
 * QR コードから公開されている動画。常に配信対象リビジョン（公開済みのうち最後に入稿されたもの）を指す。
 *
 * 既存の MediaDeliveryVideo とは別の型にしている。今は同じ形だが、あちらにフィールドが増えたときに
 * 未認証の経路へ黙って漏れることを型で止めるため。
 */
export type MediaDeliveryPublicVideo = {
  __typename?: 'MediaDeliveryPublicVideo';
  description: Maybe<Scalars['String']>;
  durationSeconds: Maybe<Scalars['Int']>;
  /** 配信元の医療機関。動画 1 件だけを引く再生ページでも医療機関名を出せるよう、動画側にも持たせる */
  facility: Facility;
  id: Scalars['ID'];
  /** 動画の内容を PDF 化した資料の署名付き URL。用意されていない場合は null */
  pdf: Maybe<MediaDeliverySignedUrl>;
  /**
   * 配信用に変換された動画。
   * 公開できる動画は必ず再生できる（公開済みリビジョンを持つ動画だけを返しているため）
   */
  stream: MediaDeliveryVideoStream;
  /** サムネイル画像の署名付き URL */
  thumbnail: MediaDeliverySignedUrl;
  title: Scalars['String'];
};

/**
 * QR コードから公開されている動画パッケージ。
 * 患者個別の配信と違い視聴状況を持たず、配信時点の動画セットも固定しない
 * （パッケージの現在の中身をそのまま見せるため、動画を足すと見える動画も増える）。
 */
export type MediaDeliveryPublicVideoPackage = {
  __typename?: 'MediaDeliveryPublicVideoPackage';
  description: Maybe<Scalars['String']>;
  facility: Facility;
  title: Scalars['String'];
  /**
   * 配信できる動画だけを、パッケージ内の表示順で返す。
   * アーカイブ済みの動画と、公開済みリビジョンを 1 件も持たない動画は含まない
   */
  videos: Array<MediaDeliveryPublicVideo>;
};

/**
 * 有効期限付きの署名付き URL。
 * 有効期限の長さはサーバ側で固定するため、リクエストからは指定できない。
 */
export type MediaDeliverySignedUrl = {
  __typename?: 'MediaDeliverySignedUrl';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

/** 動画。視聴時点の配信対象リビジョン（公開済みのうち最後に入稿されたもの）の内容を指す。 */
export type MediaDeliveryVideo = {
  __typename?: 'MediaDeliveryVideo';
  description: Maybe<Scalars['String']>;
  durationSeconds: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** 動画の内容を PDF 化した資料の署名付き URL。用意されていない場合は null */
  pdf: Maybe<MediaDeliverySignedUrl>;
  /**
   * 配信用に変換された動画。
   * 配信された動画は必ず再生できる（配信時点で配信対象のリビジョンが決まっており、公開済みなら変換も完了している）。
   * 終了した配信は動画ごと返らないため、ここには現れない
   */
  stream: MediaDeliveryVideoStream;
  /** サムネイル画像の署名付き URL */
  thumbnail: MediaDeliverySignedUrl;
  title: Scalars['String'];
};

/**
 * 患者に配信された動画 1 件と、その視聴状況。
 * 動画の内容は視聴時点の配信対象リビジョンを反映するため、配信後に新しいリビジョンが公開されると内容も変わる。
 */
export type MediaDeliveryVideoItem = {
  __typename?: 'MediaDeliveryVideoItem';
  /** 配信内の動画 1 件を指す ID。視聴開始・進捗の記録はこの ID で行う */
  id: Scalars['ID'];
  /** 前回の再生位置（秒）。続きから再生するために使う */
  lastPositionSeconds: Scalars['Int'];
  /** 最大到達進捗率（0-100）。サーバ側で再生位置と動画尺から算出した参考値で、視聴完了の判定には使わない */
  maxProgressPercent: Scalars['Int'];
  /** 付随する PDF 資料の閲覧状態。PDF が用意されていない場合は常に NOT_STARTED */
  pdfStatus: MediaDeliveryVideoItemStatus;
  /** 動画の視聴状態。患者本人が閲覧完了を申告するまで COMPLETED にはならない */
  status: MediaDeliveryVideoItemStatus;
  video: MediaDeliveryVideo;
};

/** 指定された配信内の動画が見つからない、または患者本人のものではない。 */
export type MediaDeliveryVideoItemNotFoundError = Error & {
  __typename?: 'MediaDeliveryVideoItemNotFoundError';
  message: Scalars['String'];
};

/** 配信された動画 / PDF 資料の閲覧状態。 */
export type MediaDeliveryVideoItemStatus =
  /** 閲覧完了。患者本人の申告のみで完了とし、再生進捗が 100% に達しただけでは完了にしない */
  | 'COMPLETED'
  /** 未着手 */
  | 'NOT_STARTED'
  /** 閲覧中 */
  | 'STARTED';

/**
 * 配信用に変換された動画（HLS）の署名付き URL。
 * 有効期限の長さはサーバ側で固定するため、リクエストからは指定できない。
 */
export type MediaDeliveryVideoStream = {
  __typename?: 'MediaDeliveryVideoStream';
  expiresAt: Scalars['DateTime'];
  /** HLS マルチバリアントプレイリスト（.m3u8）の URL。画質の切り替えは再生側が行う */
  url: Scalars['String'];
};

export type MedicalInstitution = Node & {
  __typename?: 'MedicalInstitution';
  abbreviatedName: Scalars['String'];
  address: Scalars['String'];
  availableElectronicPrescription: Scalars['Boolean'];
  availableMyNumberCardAsHealthInsuranceCards: Scalars['Boolean'];
  cityAddress: Scalars['String'];
  cityName: Scalars['String'];
  clinicalDepartments: Array<MedicalInstitutionClinicalDepartment>;
  closedDays: Maybe<Scalars['String']>;
  experimentalSetting: Maybe<ExperimentalSetting>;
  faxNumber: Maybe<Scalars['String']>;
  freeParkingLotCapacity: Maybe<Scalars['Int']>;
  freeParkingLotCapacityForDisabled: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFeverOutpatientAcceptable: Maybe<Scalars['Boolean']>;
  isSecondOpinionAcceptable: Maybe<Scalars['Boolean']>;
  isSecondOpinionReferralOfferable: Maybe<Scalars['Boolean']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  medicalFacilityCode: Maybe<Scalars['String']>;
  medicalSpecialists: Array<MedicalInstitutionMedicalSpecialist>;
  medicoHospital: Maybe<MedicoHospital>;
  name: Scalars['String'];
  nearestStation: Maybe<Scalars['String']>;
  openingHourTextAm: Maybe<Scalars['String']>;
  openingHourTextOthers: Maybe<Scalars['String']>;
  openingHourTextPm: Maybe<Scalars['String']>;
  openingHours: Array<MedicalInstitutionOpeningHour>;
  phoneNumber: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  prefectureName: Scalars['String'];
  reservationPreference: ReservationPreference;
  supportedCreditCards: Array<Scalars['String']>;
  supportedForeignLanguages: Array<Scalars['String']>;
  timeFromStation: Maybe<Scalars['String']>;
  transportation: Maybe<Scalars['String']>;
  websiteUrl: Maybe<Scalars['String']>;
};

export type MedicalInstitutionClinicalDepartment = {
  __typename?: 'MedicalInstitutionClinicalDepartment';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MedicalInstitutionFeatureConsent = {
  __typename?: 'MedicalInstitutionFeatureConsent';
  acceptDisclosure: Scalars['Boolean'];
  consentId: Scalars['ID'];
};

export type MedicalInstitutionFeatureConsentItem = {
  __typename?: 'MedicalInstitutionFeatureConsentItem';
  consent: Maybe<MedicalInstitutionFeatureConsent>;
  disclosure: MedicalInstitutionFeatureDisclosure;
};

export type MedicalInstitutionFeatureDisclosure = {
  __typename?: 'MedicalInstitutionFeatureDisclosure';
  content: Scalars['String'];
  disclosureId: Scalars['ID'];
  policyId: Scalars['ID'];
  title: Scalars['String'];
};

export type MedicalInstitutionMedicalSpecialist = {
  __typename?: 'MedicalInstitutionMedicalSpecialist';
  medicalSpecialist: MedicalSpecialist;
  medicalSpecialistNumberText: Maybe<Scalars['String']>;
};

export type MedicalInstitutionNotLinkedError = Error & {
  __typename?: 'MedicalInstitutionNotLinkedError';
  message: Scalars['String'];
};

export type MedicalInstitutionOpeningHour = {
  __typename?: 'MedicalInstitutionOpeningHour';
  closeTime: Scalars['String'];
  dayOfWeek: DayOfWeek;
  openTime: Scalars['String'];
};

export type MedicalSpecialist = {
  __typename?: 'MedicalSpecialist';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MedicoFacility = {
  __typename?: 'MedicoFacility';
  address: Maybe<Scalars['String']>;
  amCloseTime: Maybe<Scalars['String']>;
  amOpenTime: Maybe<Scalars['String']>;
  characteristic: Maybe<Scalars['String']>;
  closeDays: Maybe<Scalars['String']>;
  facilityMemberId: Maybe<Scalars['Int']>;
  guidance: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSignInRequiredForSmartphoneMonshin: Scalars['Boolean'];
  isSignInSkippableForSmartphoneMonshin: Scalars['Boolean'];
  medicalFacilityCode: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pmCloseTime: Maybe<Scalars['String']>;
  pmOpenTime: Maybe<Scalars['String']>;
  telephoneNumber: Maybe<Scalars['String']>;
  telephoneReceptionNote: Maybe<Scalars['String']>;
};

export type MedicoHospital = {
  __typename?: 'MedicoHospital';
  address: Maybe<Scalars['String']>;
  amCloseTime: Maybe<Scalars['String']>;
  amOpenTime: Maybe<Scalars['String']>;
  clinicalDepartments: Array<ClinicalDepartment>;
  closeDays: Maybe<Scalars['String']>;
  hospitalUserId: Maybe<Scalars['Int']>;
  isClient: Scalars['Boolean'];
  isHolidayOpeningLabelEnabled: Scalars['Boolean'];
  isLateCloseTimeLabelEnabled: Scalars['Boolean'];
  isReservationAvailable: Scalars['Boolean'];
  isUbielinkEnabled: Scalars['Boolean'];
  mainImageUrl: Maybe<Scalars['String']>;
  pmCloseTime: Maybe<Scalars['String']>;
  pmOpenTime: Maybe<Scalars['String']>;
  reservationUrl: Maybe<Scalars['String']>;
  subImageUrl1: Maybe<Scalars['String']>;
  subImageUrl2: Maybe<Scalars['String']>;
  telephoneNumber: Maybe<Scalars['String']>;
  visitingGuide: MedicoHospitalVisitingGuide;
  websiteUrl: Maybe<Scalars['String']>;
};

export type MedicoHospitalVisitingGuide = {
  __typename?: 'MedicoHospitalVisitingGuide';
  firstStep: MedicoHospitalVisitingGuideFirstStep;
};

export type MedicoHospitalVisitingGuideFirstStep = {
  __typename?: 'MedicoHospitalVisitingGuideFirstStep';
  description: Maybe<Scalars['String']>;
  googleFormUrl: Maybe<Scalars['String']>;
  otherDescription: Maybe<Scalars['String']>;
  reservationUrl: Maybe<Scalars['String']>;
  type: MedicoHospitalVisitingGuideFirstStepType;
};

export type MedicoHospitalVisitingGuideFirstStepType =
  | 'COVID19_PHONE_CONSULTATION'
  | 'GOOGLE_FORM'
  | 'OTHER'
  | 'PHONE_CONSULTATION'
  | 'PHONE_RESERVATION'
  | 'VISITING'
  | 'WEB_RESERVATION';

export type Mutation = {
  __typename?: 'Mutation';
  /** 入院前問診に回答して次の質問を取得する。 */
  answerPreAdmissionInquiry: AnswerPreAdmissionInquiryPayload;
  /**
   * 薬局予約向け: 予約登録。
   *
   * クライアント想定:
   * - OTP 検証で得た `verificationToken`・アップロード済み画像 ID・問診・個人情報を渡す
   * - 成功時の `managementToken` で完了画面の管理 URL を組み立てる（LocalStorage には保存しない）
   * - 想定内エラーは union の各型で UI 分岐。`Neox*` / `Unexpected` は Sentry 報告対象
   */
  bookPharmacy: BookPharmacyPayload;
  cancelAllMedicalInstitutionFeatureConsent: CancelAllMedicalInstitutionFeatureConsentPayload;
  /**
   * 薬局予約向け: 管理トークンによる予約キャンセル。
   *
   * クライアント想定:
   * - 管理ページのキャンセル操作から呼ぶ。Orthrus / PersonID は不要
   * - `PharmacyBookingNotCancellableError` → キャンセル不可（終端状態等）を表示
   * - `Neox*` / `Unexpected` は Sentry 報告対象
   */
  cancelPharmacyBooking: CancelPharmacyBookingPayload;
  /** 入院前問診を完了する。 */
  completePreAdmissionInquiry: CompletePreAdmissionInquiryPayload;
  /** 患者が PDF 資料を最後まで見たことを申告する。この申告のみが PDF の閲覧完了となる。 */
  completePreAdmissionVideoPdfViewing: CompletePreAdmissionVideoPdfViewingPayload;
  /** 患者が動画を最後まで見たことを申告する。この申告のみが動画の視聴完了となる。 */
  completePreAdmissionVideoViewing: CompletePreAdmissionVideoViewingPayload;
  /**
   * 来院記録（check_in）を作成する（生活者向け）。
   * 当日(JST)かつ未完了の既存チェックインがあれば再利用する（冪等）。
   * hecate の ID 連携状態に応じて、本連携済みなら診察券番号で、未連携なら仮ID連携で紐付ける。
   * 併せて患者の基本情報（氏名・カナ・性別・生年月日）を check_in に書き込み、医師向け画面の患者名表示を埋める。
   *
   * 【暫定】基本情報は本来 coedo→hecate relay→medinavi-backend(internal) で受信する想定だが、
   * relay 未実装のためチェックイン時に consumer から受け取っている。relay 実装後は基本情報フィールドを撤去する。
   */
  createCheckIn: CreateCheckInPayload;
  createMedicalInstitutionFeatureConsent: CreateMedicalInstitutionFeatureConsentPayload;
  createRequestAppointment: CreateRequestAppointmentPayload;
  createRequestAppointmentConsent: CreateRequestAppointmentConsentPayload;
  /**
   * 【開発者モード専用】集患テスト用クリニック（facilityId: 13244 固定）の患者 ID 連携コードを発行する。
   * e2e テスト・デバッグで「コード発行 → 連携実行」フローを患者アプリ起点で検証するための Mutation。
   * 本番環境では使用できない（エラーになる）。
   * 既に有効な連携コードが存在する場合はそれを返す（冪等）。
   * 既に ID 連携が完了している場合は PatientIdLinkageAlreadyLinkedCode を返す。
   */
  debugIssueTestFacilityLinkageCode: PatientIdLinkageIssuedStatus;
  /**
   * 【開発者モード専用】集患テスト用クリニック（facilityId: 13244 固定）の患者 ID 連携を解除する。
   * 連携フローの再テストを可能にするためのデバッグ用 Mutation。
   * 連携が存在しない場合・解除済みの場合も成功として扱う（冪等）。
   */
  debugUnlinkTestFacilityPatientId: DebugUnlinkTestFacilityPatientIdPayload;
  /** 会話共有リクエストを拒否する（患者アプリ向け）。同意（共有実行）は coedo→relay 経路のため consumer には持たない。 */
  declineConversationShareRequest: DeclineConversationShareRequestPayload;
  /**
   * 指導サマリーを PHR（体調管理）へ取り込む。
   * disclosureIds が指定されていれば同意保存も合わせて行う。
   * すでに取込済みの場合は何もしない（冪等）。
   */
  importLifestyleDiseaseSupportTherapy: ImportLifestyleDiseaseSupportTherapyPayload;
  /**
   * 問診画像アップロード用の signed URL を発行する。
   *
   * Patient は返却された uploadUrl に対して PUT リクエストで画像をアップロードする。
   * アップロード完了後、fileId を saveAnswer の IMAGE 回答に含めることで回答が確定する。
   * sessionId と questionUid の組み合わせが現セッションの IMAGE 質問として有効でない場合はエラーになる。
   */
  issueImageUploadUrl: IssueImageUploadUrlPayload;
  /** メールアドレス確認コードの発行 */
  issueOtpCode: IssueOtpCodePayload;
  /**
   * 薬局予約向け: 処方箋画像の署名付きアップロード URL 発行。
   *
   * クライアント想定:
   * - 予約フォームで画像選択後、GCS へ直接 PUT する前に呼ぶ
   * - 成功時の `imageId` を保持し、予約登録 Mutation の `prescriptionImageIds` に渡す
   * - `PharmacyBookingPrescriptionImageUnsupportedTypeError` → JPEG / PNG 以外。選び直しを促す
   * - `PharmacyBookingUnexpectedError` → 再試行を促す（Sentry 報告対象）
   */
  issuePharmacyBookingPrescriptionImageUploadUrl: IssuePharmacyBookingPrescriptionImageUploadUrlPayload;
  /**
   * 病院と紐づけ開始ボタン押下時に呼ぶ。未同意ポリシーの同意登録と、person × facility の病院連携登録を行う。
   * 本 Mutation は生年月日突合を含まないため、後続で linkPatientId mutation を呼んで連携を確定させる。
   */
  linkMedicalInstitutionForPatientIdLinkage: LinkMedicalInstitutionForPatientIdLinkagePayload;
  linkMedicalInstitutionsForMigration: LinkMedicalInstitutionsForMigrationPayload;
  /** 連携コードを使って患者 ID 連携を実行する */
  linkPatientId: LinkPatientIdPayload;
  /**
   * 仮ID連携（GP）の確立。同意保存・病院連携・連携状態の解決を順次実行する。
   * 複数DB（themis / medical-institution-feature / hecate）をまたぐため原子性は保証されないが、各処理は冪等で、途中失敗時は再実行で回復可能。
   * 本ID連携の linkPatientId と対称（linkPatientId が本ID連携を確立するのに対し、こちらは仮ID連携を確立する）。
   * 連携状態に応じて payload で「いずれか一方」を返す:
   *   - 本連携済み（id_linkages 存在）: facilityPatientId を返す。仮ID連携は新たに作成しない（PROMOTE 後の仮ID連携の増殖を防ぐ）。
   *   - 未連携: 仮ID連携を確立（冪等。既存 active を再利用）して provisionalIdLinkage を返す。
   * disclosureIds を内包する（空配列なら同意保存をスキップ）。ログインが前提（匿名アカウントは拒否）。
   * ※来院記録（check_in）の作成は別 mutation（createCheckIn）の責務。
   */
  linkProvisionalId: LinkProvisionalIdPayload;
  linkToMedicalInstitution: LinkedMedicalInstitution;
  makeAppointment: MakeAppointmentPayload;
  /**
   * 指導サマリーを表示済みにする（初回表示日時を記録する）。詳細画面の表示時に呼ぶ。
   * すでに表示済みの場合は何もしない（冪等）。
   */
  markLifestyleDiseaseSupportTherapyAsViewed: MarkLifestyleDiseaseSupportTherapyAsViewedPayload;
  replyRequestAppointmentProposedDates: ReplyRequestAppointmentProposedDatesPayload;
  /** 動画の再生位置を記録する。進捗率はサーバ側で算出し、単調増加でのみ更新される。 */
  reportPreAdmissionVideoProgress: ReportPreAdmissionVideoProgressPayload;
  /**
   * 薬局予約向け: メールアドレス確認コード（OTP）の発行。
   *
   * クライアント想定:
   * - 予約フローのメール入力画面で呼ぶ（ログイン不要。Orthrus 匿名 PersonID + `x-ubie-authorization`）
   * - 成功時の `emailVerificationId` を画面 state に保持し、次の OTP 入力画面へ進む（LocalStorage 不要）
   * - 再送ボタンからも同じ Mutation を呼ぶ（サーバ側で同一 PersonID の未消費 OTP を無効化）
   * - `PharmacyBookingEmailVerificationInvalidEmailError` → メール形式エラーを表示
   * - `PharmacyBookingEmailVerificationRateLimitedError` → 「しばらく待って再試行」を表示
   * - `PharmacyBookingConsentUnavailableError` → 同意記録失敗。しばらく待って再試行
   * - 成功時に themis-mis へ利用規約・プライバシーポリシー同意を記録する（ConsentID は OTP レコードに保持し予約へ引き継ぐ）
   */
  sendPharmacyBookingEmailOtp: SendPharmacyBookingEmailOtpPayload;
  /**
   * 受診メモ（PHR/coedo 生成）を MIS 側にコピーし、当日のチェックイン（check_in）に紐付ける（生活者向け）。
   * 本連携済み（id_linkages 存在＝診察券番号が解決できる）かつ 当日(JST)・未完了のチェックインがあることが前提。
   * rawRecordId（= coedo の受診メモID）を冪等キーとし、再送時は上書き保存する。
   * 分岐は payload で返す（本ID連携の linkPatientId と対称）:
   *   - 未連携（診察券番号が未解決）: errors=[LinkageNotFoundError]
   *   - 当日のチェックイン無し: errors=[CheckInNotFoundError]
   * ログインが前提（匿名アカウントは top-level error で拒否）。
   *
   * 【deprecated】PHR→MIS 正規経路（coedo.sendGpCheckinConsultationSummaryToFacility → hecate relay
   * → internal REST /api/internal/relay/gp-checkin-consultation-summaries）へ移行済み。
   * 旧アプリ版が本 mutation を叩き続けるため実体（resolver / VisitMemoRelayService）は残している。
   * medico-native の coedo 経路リリース浸透後に撤去する (KWBP-624 follow-up)。
   * @deprecated PHR→MIS 正規経路 (coedo.sendGpCheckinConsultationSummaryToFacility → hecate relay → internal) へ移行済み。medico-native の coedo 経路リリース浸透後に撤去 (KWBP-624 follow-up)。
   */
  sendVisitMemo: SendVisitMemoPayload;
  /** 入院前問診を開始し、最初の質問を取得する。ISSUED 状態の場合は MONSHIN_IN_PROGRESS に遷移する。 */
  startPreAdmissionInquiry: StartPreAdmissionInquiryPayload;
  /** 付随する PDF 資料の閲覧開始を記録する。初回のみ記録し、2 回目以降は記録済みの日時を維持する。 */
  startPreAdmissionVideoPdfViewing: StartPreAdmissionVideoPdfViewingPayload;
  /** 動画の視聴開始を記録する。再生 URL の取得は preAdmissionVideo で行う。 */
  startPreAdmissionVideoViewing: StartPreAdmissionVideoViewingPayload;
  unlinkFromMedicalInstitution: UnlinkFromMedicalInstitutionPayload;
  /** メールアドレス確認コードの検証 */
  verifyOtpCode: VerifyOtpCodePayload;
  /**
   * 薬局予約向け: メールアドレス確認コード（OTP）の検証。
   *
   * クライアント想定:
   * - OTP 入力画面で、発行時に保持した `emailVerificationId` とユーザー入力の 6 桁コードを渡す
   * - メールアドレスは送らない（capability として `emailVerificationId` のみ使う）
   * - 成功時の `verificationToken` を画面 state に保持し、続く予約登録 Mutation に渡す
   * - `PharmacyBookingEmailVerificationInvalidError` → 「コードが違う」を表示し再入力を促す
   * - `PharmacyBookingEmailVerificationUnavailableError` → 期限切れ・試行上限等。OTP 再送（send）へ誘導
   */
  verifyPharmacyBookingEmailOtp: VerifyPharmacyBookingEmailOtpPayload;
};


export type MutationAnswerPreAdmissionInquiryArgs = {
  input: AnswerPreAdmissionInquiryInput;
};


export type MutationBookPharmacyArgs = {
  input: BookPharmacyInput;
};


export type MutationCancelAllMedicalInstitutionFeatureConsentArgs = {
  personId: Scalars['ID'];
};


export type MutationCancelPharmacyBookingArgs = {
  input: CancelPharmacyBookingInput;
};


export type MutationCompletePreAdmissionInquiryArgs = {
  input: CompletePreAdmissionInquiryInput;
};


export type MutationCompletePreAdmissionVideoPdfViewingArgs = {
  input: CompletePreAdmissionVideoPdfViewingInput;
};


export type MutationCompletePreAdmissionVideoViewingArgs = {
  input: CompletePreAdmissionVideoViewingInput;
};


export type MutationCreateCheckInArgs = {
  input: CreateCheckInInput;
};


export type MutationCreateMedicalInstitutionFeatureConsentArgs = {
  disclosureIds: Array<Scalars['ID']>;
  facilityId: InputMaybe<Scalars['Int']>;
  personId: Scalars['ID'];
};


export type MutationCreateRequestAppointmentArgs = {
  input: CreateRequestAppointmentInput;
};


export type MutationCreateRequestAppointmentConsentArgs = {
  input: CreateRequestAppointmentConsentInput;
};


export type MutationDebugIssueTestFacilityLinkageCodeArgs = {
  input: DebugIssueTestFacilityLinkageCodeInput;
};


export type MutationDebugUnlinkTestFacilityPatientIdArgs = {
  input: DebugUnlinkTestFacilityPatientIdInput;
};


export type MutationDeclineConversationShareRequestArgs = {
  input: DeclineConversationShareRequestInput;
};


export type MutationImportLifestyleDiseaseSupportTherapyArgs = {
  input: ImportLifestyleDiseaseSupportTherapyInput;
};


export type MutationIssueImageUploadUrlArgs = {
  input: IssueImageUploadUrlInput;
};


export type MutationIssueOtpCodeArgs = {
  input: IssueOtpCodeInput;
};


export type MutationIssuePharmacyBookingPrescriptionImageUploadUrlArgs = {
  input: IssuePharmacyBookingPrescriptionImageUploadUrlInput;
};


export type MutationLinkMedicalInstitutionForPatientIdLinkageArgs = {
  input: LinkMedicalInstitutionForPatientIdLinkageInput;
};


export type MutationLinkMedicalInstitutionsForMigrationArgs = {
  input: LinkMedicalInstitutionsForMigrationInput;
};


export type MutationLinkPatientIdArgs = {
  input: LinkPatientIdInput;
};


export type MutationLinkProvisionalIdArgs = {
  input: LinkProvisionalIdInput;
};


export type MutationLinkToMedicalInstitutionArgs = {
  input: LinkToMedicalInstitutionInput;
};


export type MutationMakeAppointmentArgs = {
  input: MakeAppointmentInput;
};


export type MutationMarkLifestyleDiseaseSupportTherapyAsViewedArgs = {
  input: MarkLifestyleDiseaseSupportTherapyAsViewedInput;
};


export type MutationReplyRequestAppointmentProposedDatesArgs = {
  input: ReplyRequestAppointmentProposedDatesInput;
};


export type MutationReportPreAdmissionVideoProgressArgs = {
  input: ReportPreAdmissionVideoProgressInput;
};


export type MutationSendPharmacyBookingEmailOtpArgs = {
  input: SendPharmacyBookingEmailOtpInput;
};


export type MutationSendVisitMemoArgs = {
  input: SendVisitMemoInput;
};


export type MutationStartPreAdmissionInquiryArgs = {
  input: StartPreAdmissionInquiryInput;
};


export type MutationStartPreAdmissionVideoPdfViewingArgs = {
  input: StartPreAdmissionVideoPdfViewingInput;
};


export type MutationStartPreAdmissionVideoViewingArgs = {
  input: StartPreAdmissionVideoViewingInput;
};


export type MutationUnlinkFromMedicalInstitutionArgs = {
  input: UnlinkFromMedicalInstitutionInput;
};


export type MutationVerifyOtpCodeArgs = {
  input: VerifyOtpCodeInput;
};


export type MutationVerifyPharmacyBookingEmailOtpArgs = {
  input: VerifyPharmacyBookingEmailOtpInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type PatientIdLinkage = {
  __typename?: 'PatientIdLinkage';
  facilityId: Scalars['Int'];
  facilityPatientId: Scalars['String'];
  /** 実際の連携完了時刻。Hecate が linkedAt を返すようになるまでは null になる。 */
  linkedAt: Maybe<Scalars['DateTime']>;
  personId: Scalars['ID'];
};

export type PatientIdLinkageAlreadyExistsError = Error & {
  __typename?: 'PatientIdLinkageAlreadyExistsError';
  message: Scalars['String'];
};

/** ID 連携が既に確立済みの状態を表す結果型。__typename で判別する。 */
export type PatientIdLinkageAlreadyLinkedCode = {
  __typename?: 'PatientIdLinkageAlreadyLinkedCode';
  alreadyLinkedCode: PatientIdLinkageAlreadyLinkedCodeValue;
};

export type PatientIdLinkageAlreadyLinkedCodeValue =
  | 'ALREADY_LINKED';

export type PatientIdLinkageFlowContext = {
  __typename?: 'PatientIdLinkageFlowContext';
  facility: Facility;
  isMedicalInstitutionLinked: Scalars['Boolean'];
  /** 既に患者 ID 連携済みならその情報。未連携なら null */
  patientIdLinkage: Maybe<PatientIdLinkage>;
  /** 未同意のポリシーのみ。空配列なら同意取得は不要 */
  requiredConsents: Array<ConsentItem>;
};

export type PatientIdLinkageFlowContextError = AnonymousAccountError | LinkageCodeAlreadyUsedError | LinkageCodeExpiredError | LinkageCodeLockedError | LinkageCodeNotFoundError | LinkageCodePatientMismatchError | PatientNotFoundInEmrError;

export type PatientIdLinkageFlowContextInput = {
  /**
   * 医療機関 ID。常に必須。
   * 通常コード（認証あり）時は Hecate resolveLinkageCode から取得するため facilityId の値は無視する。
   */
  facilityId: Scalars['Int'];
  /** 連携コード。通常コードまたは連携済みコード特殊値 `ALREADY_LINKED` のいずれかを必ず渡す */
  linkageCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type PatientIdLinkageFlowContextPayload = {
  __typename?: 'PatientIdLinkageFlowContextPayload';
  context: Maybe<PatientIdLinkageFlowContext>;
  errors: Array<PatientIdLinkageFlowContextError>;
};

/** 有効な連携コード発行済の状態。連携用 QR を表示できる。 */
export type PatientIdLinkageIssued = {
  __typename?: 'PatientIdLinkageIssued';
  code: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

/**
 * 連携コード発行直後に取り得る ID 連携状態。発行直後のため Issued か AlreadyLinkedCode のいずれか。
 * FE は __typename で判別する。
 */
export type PatientIdLinkageIssuedStatus = PatientIdLinkageAlreadyLinkedCode | PatientIdLinkageIssued;

export type PatientIdNotLinkedError = Error & {
  __typename?: 'PatientIdNotLinkedError';
  message: Scalars['String'];
};

export type PatientNotFoundInEmrError = Error & {
  __typename?: 'PatientNotFoundInEmrError';
  message: Scalars['String'];
};

export type PharmacyBooking = {
  __typename?: 'PharmacyBooking';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** このトークンでキャンセル可能か */
  isCancellable: Scalars['Boolean'];
  personalInformation: PharmacyBookingPersonalInformation;
  pharmacyId: Scalars['ID'];
  questionnaire: PharmacyBookingQuestionnaire;
  status: PharmacyBookingStatus;
  timeSlot: PharmacyBookingTimeSlot;
};

/** 先発医薬品の希望 */
export type PharmacyBookingBrandNameDrugPreference =
  | 'NOT_PREFER'
  | 'PREFER';

export type PharmacyBookingByManagementTokenError = PharmacyBookingInvalidManagementTokenError | PharmacyBookingManagementTokenExpiredError | PharmacyBookingUnexpectedError;

export type PharmacyBookingByManagementTokenInput = {
  /** 管理トークン平文（管理 URL のパスから取得） */
  managementToken: Scalars['String'];
};

export type PharmacyBookingByManagementTokenPayload = {
  __typename?: 'PharmacyBookingByManagementTokenPayload';
  booking: Maybe<PharmacyBooking>;
  errors: Array<PharmacyBookingByManagementTokenError>;
};

export type PharmacyBookingConsentItem = {
  __typename?: 'PharmacyBookingConsentItem';
  /** 同意文面本文（Markdown 等） */
  content: Scalars['String'];
  /** themis-mis disclosure ID（記録時と同一である必要がある） */
  disclosureId: Scalars['ID'];
  /** themis-mis policy ID */
  policyId: Scalars['ID'];
  /** 同意チェックボックス等に表示するタイトル */
  title: Scalars['String'];
};

/** 同意記録が取得できない */
export type PharmacyBookingConsentUnavailableError = Error & {
  __typename?: 'PharmacyBookingConsentUnavailableError';
  message: Scalars['String'];
};

/** メールアドレス形式エラー */
export type PharmacyBookingEmailVerificationInvalidEmailError = Error & {
  __typename?: 'PharmacyBookingEmailVerificationInvalidEmailError';
  message: Scalars['String'];
};

/** 確認コード不一致、または対象レコードが存在しない */
export type PharmacyBookingEmailVerificationInvalidError = Error & {
  __typename?: 'PharmacyBookingEmailVerificationInvalidError';
  message: Scalars['String'];
};

/** レート制限エラー（一定時間内に確認コードの送信回数が上限に達した） */
export type PharmacyBookingEmailVerificationRateLimitedError = Error & {
  __typename?: 'PharmacyBookingEmailVerificationRateLimitedError';
  message: Scalars['String'];
};

/** 確認コードが利用不可（有効期限切れ・無効化・消費済み・試行上限・競合） */
export type PharmacyBookingEmailVerificationUnavailableError = Error & {
  __typename?: 'PharmacyBookingEmailVerificationUnavailableError';
  message: Scalars['String'];
};

/** 管理トークンが無効 */
export type PharmacyBookingInvalidManagementTokenError = Error & {
  __typename?: 'PharmacyBookingInvalidManagementTokenError';
  message: Scalars['String'];
};

/** 個人情報が無効（15 歳未満で体重未入力等） */
export type PharmacyBookingInvalidPersonalInformationError = Error & {
  __typename?: 'PharmacyBookingInvalidPersonalInformationError';
  message: Scalars['String'];
};

/** 受け取り希望日時が選択不可 */
export type PharmacyBookingInvalidTimeSlotError = Error & {
  __typename?: 'PharmacyBookingInvalidTimeSlotError';
  message: Scalars['String'];
};

/** 確認トークンが無効（不一致・未消費・無効化等） */
export type PharmacyBookingInvalidVerificationTokenError = Error & {
  __typename?: 'PharmacyBookingInvalidVerificationTokenError';
  message: Scalars['String'];
};

/** 管理トークンが期限切れ */
export type PharmacyBookingManagementTokenExpiredError = Error & {
  __typename?: 'PharmacyBookingManagementTokenExpiredError';
  message: Scalars['String'];
};

/** お薬手帳の持参意向 */
export type PharmacyBookingMedicationNotebookIntention =
  | 'BRING'
  | 'BRING_ELECTRONIC'
  | 'NONE'
  | 'NOT_BRING';

/** 予約がキャンセル不可（終端状態等） */
export type PharmacyBookingNotCancellableError = Error & {
  __typename?: 'PharmacyBookingNotCancellableError';
  message: Scalars['String'];
};

/** 外部薬局連携（予約登録）に失敗 */
export type PharmacyBookingPartnerBookingFailedError = Error & {
  __typename?: 'PharmacyBookingPartnerBookingFailedError';
  message: Scalars['String'];
};

/** 外部薬局連携（キャンセル）に失敗（要監視） */
export type PharmacyBookingPartnerCancelFailedError = Error & {
  __typename?: 'PharmacyBookingPartnerCancelFailedError';
  message: Scalars['String'];
};

export type PharmacyBookingPersonalInformation = {
  __typename?: 'PharmacyBookingPersonalInformation';
  email: Scalars['String'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  /** 体重（kg）。未入力時は null */
  weightKg: Maybe<Scalars['Float']>;
};

/** 薬局予約の薬局マスタ（生活者向け表示） */
export type PharmacyBookingPharmacy = {
  __typename?: 'PharmacyBookingPharmacy';
  address: Scalars['String'];
  businessHours: PharmacyBookingPharmacyBusinessHours;
  id: Scalars['ID'];
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phoneNumber: Maybe<Scalars['String']>;
  /** 受付条件・注意事項（Ubie 側文言） */
  receptionConditions: Array<Scalars['String']>;
  /** 選択可能な受け取り希望枠の開始日時（UTC DateTime）。営業時間・臨時休業・祝日を反映済み */
  selectablePickupTimeSlotStartsAt: Array<Scalars['DateTime']>;
  temporaryClosures: Array<PharmacyBookingPharmacyTemporaryClosure>;
};

export type PharmacyBookingPharmacyBusinessHours = {
  __typename?: 'PharmacyBookingPharmacyBusinessHours';
  /** 法定休日の営業時間。空配列は法定休日休業 */
  legalHoliday: Array<PharmacyBookingPharmacyTimeRange>;
  /** 曜日別営業時間。休業の曜日は配列に含めない（空の timeRanges も休業） */
  weekdays: Array<PharmacyBookingPharmacyWeekdayHours>;
};

export type PharmacyBookingPharmacyError = PharmacyBookingPharmacyNotFoundError;

/** 未知 ID・予約受付不可（NeoX 店舗マスターに存在しない等） */
export type PharmacyBookingPharmacyNotFoundError = Error & {
  __typename?: 'PharmacyBookingPharmacyNotFoundError';
  message: Scalars['String'];
};

export type PharmacyBookingPharmacyPayload = {
  __typename?: 'PharmacyBookingPharmacyPayload';
  errors: Array<PharmacyBookingPharmacyError>;
  pharmacy: Maybe<PharmacyBookingPharmacy>;
};

export type PharmacyBookingPharmacyTemporaryClosure = {
  __typename?: 'PharmacyBookingPharmacyTemporaryClosure';
  /** JST カレンダー日（YYYY-MM-DD） */
  date: Scalars['String'];
  timeRanges: Array<PharmacyBookingPharmacyTimeRange>;
};

/** 時刻（JST）。close のみ hour=24 / minute=0 で当日終端を表す */
export type PharmacyBookingPharmacyTimeOfDay = {
  __typename?: 'PharmacyBookingPharmacyTimeOfDay';
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type PharmacyBookingPharmacyTimeRange = {
  __typename?: 'PharmacyBookingPharmacyTimeRange';
  close: PharmacyBookingPharmacyTimeOfDay;
  open: PharmacyBookingPharmacyTimeOfDay;
};

/** 曜日（月曜始まり） */
export type PharmacyBookingPharmacyWeekday =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type PharmacyBookingPharmacyWeekdayHours = {
  __typename?: 'PharmacyBookingPharmacyWeekdayHours';
  timeRanges: Array<PharmacyBookingPharmacyTimeRange>;
  weekday: PharmacyBookingPharmacyWeekday;
};

/** 受け取りは本人か代理人か */
export type PharmacyBookingPickupRecipientType =
  | 'PROXY'
  | 'SELF';

/** 処方箋画像が上限枚数（5 枚）を超えている */
export type PharmacyBookingPrescriptionImageLimitExceededError = Error & {
  __typename?: 'PharmacyBookingPrescriptionImageLimitExceededError';
  message: Scalars['String'];
};

/** 処方箋画像が存在しない */
export type PharmacyBookingPrescriptionImageNotFoundError = Error & {
  __typename?: 'PharmacyBookingPrescriptionImageNotFoundError';
  message: Scalars['String'];
};

/** 処方箋画像が未指定 */
export type PharmacyBookingPrescriptionImageRequiredError = Error & {
  __typename?: 'PharmacyBookingPrescriptionImageRequiredError';
  message: Scalars['String'];
};

/** 処方箋画像が既に他予約に紐づいている */
export type PharmacyBookingPrescriptionImageUnavailableError = Error & {
  __typename?: 'PharmacyBookingPrescriptionImageUnavailableError';
  message: Scalars['String'];
};

/** 処方箋画像の形式が未対応（JPEG / PNG 以外） */
export type PharmacyBookingPrescriptionImageUnsupportedTypeError = Error & {
  __typename?: 'PharmacyBookingPrescriptionImageUnsupportedTypeError';
  message: Scalars['String'];
};

export type PharmacyBookingQuestionnaire = {
  __typename?: 'PharmacyBookingQuestionnaire';
  brandNameDrugPreference: PharmacyBookingBrandNameDrugPreference;
  medicationNotebookIntention: PharmacyBookingMedicationNotebookIntention;
  pickupRecipientType: PharmacyBookingPickupRecipientType;
};

/** 予約の現在状態 */
export type PharmacyBookingStatus =
  | 'ABORTED'
  | 'CANCELLED'
  | 'DISPENSED'
  | 'PICKED_UP'
  | 'RECEIVED';

export type PharmacyBookingTimeSlot = {
  __typename?: 'PharmacyBookingTimeSlot';
  endsAt: Scalars['DateTime'];
  startsAt: Scalars['DateTime'];
};

/** 予期せぬエラー */
export type PharmacyBookingUnexpectedError = Error & {
  __typename?: 'PharmacyBookingUnexpectedError';
  message: Scalars['String'];
};

/** 確認トークンが既に使用済み */
export type PharmacyBookingVerificationTokenAlreadyUsedError = Error & {
  __typename?: 'PharmacyBookingVerificationTokenAlreadyUsedError';
  message: Scalars['String'];
};

export type PhrShareableMedicalInstitutionLink = {
  __typename?: 'PhrShareableMedicalInstitutionLink';
  adjustToken: Maybe<Scalars['String']>;
  consentId: Scalars['ID'];
  isDeveloper: Scalars['Boolean'];
  isMigrationData: Scalars['Boolean'];
  linkCodeId: Scalars['ID'];
  linkedAt: Scalars['DateTime'];
  medicalInstitutionId: Maybe<Scalars['ID']>;
  personId: Scalars['ID'];
};

export type PhrShareableMedicalInstitutionLinksInput = {
  personId: Scalars['ID'];
};

/** 入院前問診。回答フローそのものは preAdmissionInquiryStatus 以降の query / mutation で扱う。 */
export type PreAdmissionInquiry = {
  __typename?: 'PreAdmissionInquiry';
  id: Scalars['ID'];
  status: PreAdmissionInquiryStatus;
};

export type PreAdmissionInquiryAlreadyCompletedError = Error & {
  __typename?: 'PreAdmissionInquiryAlreadyCompletedError';
  message: Scalars['String'];
};

export type PreAdmissionInquiryNotFoundError = Error & {
  __typename?: 'PreAdmissionInquiryNotFoundError';
  message: Scalars['String'];
};

export type PreAdmissionInquiryQuestionError = AnonymousAccountError | ConsentNotGivenError | MedicalInstitutionNotLinkedError | PatientIdNotLinkedError | PreAdmissionInquiryNotFoundError | SessionQuestionNotFoundError;

export type PreAdmissionInquiryQuestionPayload = {
  __typename?: 'PreAdmissionInquiryQuestionPayload';
  errors: Array<PreAdmissionInquiryQuestionError>;
  result: Maybe<PreAdmissionInquiryQuestionResult>;
};

export type PreAdmissionInquiryQuestionResult = {
  __typename?: 'PreAdmissionInquiryQuestionResult';
  /** 画像アップロード用 mutation で必要な askman セッション ID */
  askmanSessionId: Scalars['ID'];
  progress: AskmanSessionProgress;
  /** 指定 UID に対応する質問 */
  sessionQuestion: AskmanSessionQuestion;
};

/** 入院前問診のステータス */
export type PreAdmissionInquiryStatus =
  /** QR 発行済み・患者未読取 */
  | 'ISSUED'
  /** 問診完了 */
  | 'MONSHIN_DONE'
  /** 問診中 */
  | 'MONSHIN_IN_PROGRESS';

export type PreAdmissionInquiryStatusError = AnonymousAccountError | PatientIdNotLinkedError | PreAdmissionInquiryNotFoundError;

export type PreAdmissionInquiryStatusPayload = {
  __typename?: 'PreAdmissionInquiryStatusPayload';
  errors: Array<PreAdmissionInquiryStatusError>;
  result: Maybe<PreAdmissionInquiryStatusResult>;
};

export type PreAdmissionInquiryStatusResult = {
  __typename?: 'PreAdmissionInquiryStatusResult';
  /** 画像アップロード用 mutation で必要な askman セッション ID */
  askmanSessionId: Scalars['ID'];
  facility: Facility;
  /** 病院連携済みかどうか。false の場合は連携フローへ誘導する */
  isMedicalInstitutionLinked: Scalars['Boolean'];
  /** 対象患者の情報 */
  patient: EmrPatient;
  preAdmissionInquiryId: Scalars['ID'];
  /** 未同意のポリシー一覧。空配列なら同意取得は不要 */
  requiredConsents: Array<ConsentItem>;
  status: PreAdmissionInquiryStatus;
};

/**
 * 入院前の動画配信。患者 1 人に対して「まとめて配信した動画の束」を表す。
 * 1 つの入院支援に対する配信は 1 件だけ（追加配信は行わない）。
 * 視聴進捗の記録はこの ID と配信内の動画 ID の組で行うため、動画はこの型を介して辿る。
 */
export type PreAdmissionVideo = {
  __typename?: 'PreAdmissionVideo';
  /** 配信日。一覧を配信日でセクション分けするために使う。レコードの作成日時ではない */
  deliveredAt: Scalars['DateTime'];
  /** 配信ID（admission_support.pre_admission_videos.id）。視聴進捗系の query / mutation に渡す */
  id: Scalars['ID'];
  /** 配信された動画。配信時に決まった順で返す */
  items: Array<MediaDeliveryVideoItem>;
};

export type PreAdmissionVideoError = AnonymousAccountError | MediaDeliveryVideoItemNotFoundError | MedicalInstitutionNotLinkedError | PatientIdNotLinkedError;

export type PreAdmissionVideoPayload = {
  __typename?: 'PreAdmissionVideoPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<PreAdmissionVideoResult>;
};

export type PreAdmissionVideoResult = {
  __typename?: 'PreAdmissionVideoResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type PreAdmissionVideosPayload = {
  __typename?: 'PreAdmissionVideosPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<PreAdmissionVideosResult>;
};

export type PreAdmissionVideosResult = {
  __typename?: 'PreAdmissionVideosResult';
  /** 配信日の新しい順。配信が無い場合は空配列 */
  preAdmissionVideos: Array<PreAdmissionVideo>;
};

/** 仮ID連携（person × facility の暫定的な紐付け。本ID連携前のプレースホルダ） */
export type ProvisionalIdLinkage = {
  __typename?: 'ProvisionalIdLinkage';
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
  provisionalIdLinkageId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * 対応が必要な入院支援の一覧を取得する。返るのは対応が必要なものだけで、
   * 未完了の入院前問診または未視聴の動画があり、かつ案内期間内のものに限る。
   *
   * facilityId を省略すると医療機関横断で取得する（病院タブトップ用）。
   * 指定すると当該医療機関のみを取得する（病院詳細用）。
   */
  actionRequiredAdmissionSupports: ActionRequiredAdmissionSupportsPayload;
  /**
   * 入院支援 1 件を取得する。「今回の入院に関するやってもらうことリスト」画面で使う。
   * 入院前問診と配信された動画は AdmissionSupport のフィールドから辿る。
   */
  admissionSupport: AdmissionSupportPayload;
  availableLinkMedicalInstitutions: Array<AvailableLinkMedicalInstitution>;
  /**
   * 6桁コードから入った患者がどちらの導線に入るべきかを1つの値で返す（患者アプリの分岐画面向け）。
   * 導線の選択は医療機関設定（linkedCompleteScreen）だけで決まり、チェックイン履歴は使わない
   * —— GP 設定さえあれば履歴 0 件でも GP_CHECKIN になる。履歴が効くのは isRepeatVisit
   * （導線に入った後、同意画面と本人情報入力をスキップしてよいか）だけ。
   * クライアントは履歴を見て自分で分岐しない。
   * linkCode が存在しない場合は null。
   */
  checkInRouteDecision: Maybe<CheckInRouteDecision>;
  /**
   * 指定医療機関から自分宛に届いている会話共有リクエスト（pending のみ）を取得する（患者アプリ向け）。
   * 病院詳細・会話履歴のカード表示に使う。ID 連携済みでない場合は空配列。
   * 表示用にエスカレーション通知の要約・日時を同梱する。
   * rawRecordId（= coedo.phr_escalations.id）はアプリが coedo で会話セッションに解決するキー。
   */
  conversationShareRequests: Array<ConversationShareRequestForConsumer>;
  /**
   * GPチェックインの受診メモ（ConsultationSummary）の内容を id 指定で取得する。
   * 受診記録詳細ページの表示用。
   * personId で認証したうえで、当該 personId の CheckIn 経由で到達できる受診メモのみ返す
   * （= linkedMedicalInstitutions().feature.gpCheckin.checkinHistory が consultationSummaryId を
   * 返したのと同じスコープ）。到達できない場合（他 person の受診メモ、id 不存在）は null を返す。
   */
  gpCheckinConsultationSummary: Maybe<GpCheckinConsultationSummary>;
  /**
   * 取込可能（PHR 未登録かつ未取消）な指導サマリー一覧を送信日時の降順で取得する。
   * facilityId 未指定なら ID 連携済みの全医療機関分（病院タブトップ用）、
   * 指定ならその医療機関分（病院詳細「病院からのお願い」用）。
   */
  importableLifestyleDiseaseSupportTherapies: Array<LifestyleDiseaseSupportTherapy>;
  /**
   * 指定医療機関への自分の前回チェックインから、基本情報（氏名・カナ・性別・生年月日）を取得する（患者アプリ向け）。
   * 2回目以降のチェックインで同じ情報の再入力を省くために使う。
   * 同一医療機関への当該患者の check_in が無い（＝その医療機関には初めてのチェックイン）場合や、
   * 6項目のいずれかが欠けている（未書き込み）場合は null を返す —— 部分プリフィルはしない。
   * 診察券番号（facilityPatientId）はここでは返さない（本人情報の読み口と診察券番号の読み口は分離する）。
   */
  lastCheckInBasicInfo: Maybe<CheckInBasicInfo>;
  /**
   * 指定医療機関の指導サマリー一覧を送信日時の降順で取得する（書類一覧用。取込済みを含む）。
   * 取消済み（revoked）の指導サマリーは含まない。
   */
  lifestyleDiseaseSupportTherapies: Array<LifestyleDiseaseSupportTherapy>;
  /**
   * 指導サマリー詳細を取得する。
   * facilityId は ID 連携状態の解決（RLS の患者コンテキスト）に使う。
   * 閲覧できない場合（未連携・取消済み・他人のレコード等）は null を返す。
   */
  lifestyleDiseaseSupportTherapy: Maybe<LifestyleDiseaseSupportTherapy>;
  linkMedicalInstitutionFaq: Array<LinkMedicalInstitutionFaqItem>;
  linkedMedicalInstitutions: Array<LinkedMedicalInstitution>;
  /**
   * 公開トークンから動画 1 件を解決する（QR コード経由の視聴）。
   * sushiro の /media-delivery/{facilityId}/{token}/{videoId} から呼び出される。
   *
   * videoId がそのパッケージに属さない場合も、上と同じ理由ですべて null に倒す。
   */
  mediaDeliveryPublicVideoByToken: Maybe<MediaDeliveryPublicVideo>;
  /**
   * 公開トークンから動画パッケージを解決する（QR コード経由の視聴）。
   * sushiro の /media-delivery/{facilityId}/{token} から呼び出される。
   *
   * トークン文字列自体が access control なのでユーザー認証は要求せず、視聴状況も記録しない。
   * facilityId は RLS の医療機関コンテキストに使うため、トークンと対で受け取る。
   *
   * 見つからない状態はすべて null に倒す（トークン不正・未登録・公開終了・
   * facilityId とトークンの不一致・パッケージのアーカイブ・配信できる動画が 0 本）。
   * 区別すると「実在するが終了済み」が判別でき、トークン列挙のオラクルになるため。
   */
  mediaDeliveryPublicVideoPackageByToken: Maybe<MediaDeliveryPublicVideoPackage>;
  medicalInstitution: Maybe<MedicalInstitution>;
  medicalInstitutionFeatureConsents: Array<MedicalInstitutionFeatureConsentItem>;
  medicoFacilityByFacilityMemberId: Maybe<MedicoFacility>;
  medicoFacilityByFacilityMemberKey: Maybe<MedicoFacility>;
  medicoFacilityByKeyOrId: Maybe<MedicoFacility>;
  /**
   * 患者 ID 連携フローの処理用画面で 1 回だけ呼ぶ集約 Query。
   * Deep Link からの初回処理時に必要な医療機関情報・連携状態・未同意ポリシーをまとめて返す。
   * token 種別（通常コード / 連携済みコード特殊値）ごとの追加条件チェックも行い、
   * 満たさない場合は エラー画面遷移用のエラーを返す。
   * 次にどの画面へ進めるか（nextStep）はサーバでは判定せず、フロント側で返却値をもとに分岐する。
   */
  patientIdLinkageFlowContext: PatientIdLinkageFlowContextPayload;
  /**
   * 薬局予約向けの薬局詳細（名称・住所・営業時間・選択可能受け取り枠等）。
   *
   * クライアント想定:
   * - Google 導線のランディング（`/pharmacy-bookings/[pharmacyId]`）から呼ぶ
   * - 公開マスタのため Orthrus / PersonID は不要（`requestAppointmentFacility` / `medicalInstitution` と同型）
   * - `PharmacyBookingPharmacyNotFoundError` → 未掲載・未知 ID として 404 相当の表示
   * - 選択可能受け取り枠は本レスポンスに含まれる（独立 Query は作らない）
   */
  pharmacy: PharmacyBookingPharmacyPayload;
  /**
   * 薬局予約向け: 管理トークンによる予約確認。
   *
   * クライアント想定:
   * - 管理ページ（メールの管理 URL）から呼ぶ。Orthrus / PersonID は不要（トークンがログイン代替）
   * - 処方箋画像は含まれない
   * - `PharmacyBookingInvalidManagementTokenError` → 無効リンク表示
   * - `PharmacyBookingManagementTokenExpiredError` → 期限切れ表示
   */
  pharmacyBookingByManagementToken: PharmacyBookingByManagementTokenPayload;
  /**
   * 薬局予約の必須同意文面（表示用）。記録は sendPharmacyBookingEmailOtp 側。
   * Person 非依存（personId 不要）。themis 取得には Orthrus IAT が必要。
   */
  pharmacyBookingConsents: Array<PharmacyBookingConsentItem>;
  phrShareableMedicalInstitutionLinks: Array<PhrShareableMedicalInstitutionLink>;
  /** 指定した質問 UID の質問情報を取得する。 */
  preAdmissionInquiryQuestion: PreAdmissionInquiryQuestionPayload;
  /** 入院前問診のステータスを取得する。認可チェック（同意・病院連携・患者 ID 連携）を行う。 */
  preAdmissionInquiryStatus: PreAdmissionInquiryStatusPayload;
  /** 配信された動画 1 件の詳細を取得する。再生 URL もここで発行する。 */
  preAdmissionVideo: PreAdmissionVideoPayload;
  /**
   * 患者に配信された入院前動画を配信単位で一覧する。「病院からの動画」画面で使う。
   *
   * 配信日の新しい順で返す。動画が 1 件も残っていない配信（全動画がアーカイブされた等）は含まれない。
   * 入院支援を辿らず配信だけを一覧するため、入院支援の「対応が必要」判定とは無関係に
   * 過去の配信もすべて返す。
   */
  preAdmissionVideos: PreAdmissionVideosPayload;
  /**
   * 公開トークン文字列で有効な医療機関リダイレクト先を 1 件取得する。
   * sushiro の /redirect/medical-institution-link/{token} ハンドラから呼び出す。
   * deactivated 済みは null を返す。
   */
  redirectTokenByToken: Maybe<RedirectToken>;
  requestAppointmentCards: Array<RequestAppointmentCard>;
  requestAppointmentConsentItems: Array<ConsentItem>;
  requestAppointmentFacility: RequestAppointmentFacility;
  requestAppointmentPresets: RequestAppointmentPresets;
  /**
   * 指導サマリーの PHR 取込に必要な未同意ポリシー一覧を取得する。
   * 現状はプライバシーポリシーの再確認（機能全体で初回 1 回）のみだが、
   * 将来 facility 単位の同意ポリシーが追加される可能性を考慮し facilityId を必須で受け取る。
   * 空配列なら同意モーダルの表示は不要。
   */
  requiredConsentsForLifestyleDiseaseSupportTherapyImport: Array<ConsentItem>;
};


export type QueryActionRequiredAdmissionSupportsArgs = {
  facilityId: InputMaybe<Scalars['Int']>;
  personId: Scalars['ID'];
};


export type QueryAdmissionSupportArgs = {
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  personId: Scalars['ID'];
};


export type QueryCheckInRouteDecisionArgs = {
  linkCode: Scalars['String'];
  personId: Scalars['ID'];
};


export type QueryConversationShareRequestsArgs = {
  input: ConversationShareRequestsInput;
};


export type QueryGpCheckinConsultationSummaryArgs = {
  input: GpCheckinConsultationSummaryInput;
};


export type QueryImportableLifestyleDiseaseSupportTherapiesArgs = {
  facilityId: InputMaybe<Scalars['Int']>;
  personId: Scalars['ID'];
};


export type QueryLastCheckInBasicInfoArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryLifestyleDiseaseSupportTherapiesArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryLifestyleDiseaseSupportTherapyArgs = {
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  personId: Scalars['ID'];
};


export type QueryLinkMedicalInstitutionFaqArgs = {
  linkCode: Scalars['String'];
};


export type QueryLinkedMedicalInstitutionsArgs = {
  input: LinkedMedicalInstitutionsInput;
};


export type QueryMediaDeliveryPublicVideoByTokenArgs = {
  facilityId: Scalars['Int'];
  token: Scalars['String'];
  videoId: Scalars['ID'];
};


export type QueryMediaDeliveryPublicVideoPackageByTokenArgs = {
  facilityId: Scalars['Int'];
  token: Scalars['String'];
};


export type QueryMedicalInstitutionArgs = {
  id: Scalars['ID'];
};


export type QueryMedicalInstitutionFeatureConsentsArgs = {
  facilityId: InputMaybe<Scalars['Int']>;
  personId: Scalars['ID'];
};


export type QueryMedicoFacilityByFacilityMemberIdArgs = {
  facilityMemberId: Scalars['Int'];
};


export type QueryMedicoFacilityByFacilityMemberKeyArgs = {
  facilityMemberKey: Scalars['String'];
};


export type QueryMedicoFacilityByKeyOrIdArgs = {
  keyOrId: Scalars['String'];
};


export type QueryPatientIdLinkageFlowContextArgs = {
  input: PatientIdLinkageFlowContextInput;
};


export type QueryPharmacyArgs = {
  id: Scalars['ID'];
};


export type QueryPharmacyBookingByManagementTokenArgs = {
  input: PharmacyBookingByManagementTokenInput;
};


export type QueryPhrShareableMedicalInstitutionLinksArgs = {
  input: PhrShareableMedicalInstitutionLinksInput;
};


export type QueryPreAdmissionInquiryQuestionArgs = {
  personId: Scalars['ID'];
  preAdmissionInquiryId: Scalars['ID'];
  questionUid: Scalars['String'];
};


export type QueryPreAdmissionInquiryStatusArgs = {
  personId: Scalars['ID'];
  preAdmissionInquiryId: Scalars['ID'];
};


export type QueryPreAdmissionVideoArgs = {
  facilityId: Scalars['Int'];
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  preAdmissionVideoId: Scalars['ID'];
};


export type QueryPreAdmissionVideosArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryRedirectTokenByTokenArgs = {
  token: Scalars['String'];
};


export type QueryRequestAppointmentCardsArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryRequestAppointmentConsentItemsArgs = {
  personId: Scalars['ID'];
};


export type QueryRequestAppointmentFacilityArgs = {
  facilityId: Scalars['Int'];
};


export type QueryRequestAppointmentPresetsArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryRequiredConsentsForLifestyleDiseaseSupportTherapyImportArgs = {
  facilityId: Scalars['Int'];
  personId: Scalars['ID'];
};

/** 医療機関リダイレクト解決結果。sushiro のリダイレクトハンドラに必要な最小フィールドのみ公開する。 */
export type RedirectToken = {
  __typename?: 'RedirectToken';
  purpose: Scalars['String'];
  redirectUrl: Scalars['String'];
};

/** 医療機関から提案された日時への返信 */
export type ReplyRequestAppointmentProposedDatesInput = {
  personId: Scalars['ID'];
  requestAppointmentId: Scalars['ID'];
  results: Array<RequestAppointmentProposedDateResultInput>;
};

export type ReplyRequestAppointmentProposedDatesPayload = {
  __typename?: 'ReplyRequestAppointmentProposedDatesPayload';
  requestAppointmentCard: RequestAppointmentCard;
};

export type ReportPreAdmissionVideoProgressInput = {
  /** 配信元の医療機関 ID。患者を一意に特定するために必須 */
  facilityId: Scalars['Int'];
  /** 配信内の動画 1 件の ID */
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  /** 現在の再生位置（秒）。進捗率はこの値と動画尺からサーバ側で算出する */
  positionSeconds: Scalars['Int'];
  /** 入院前の動画配信 ID（配信単位） */
  preAdmissionVideoId: Scalars['ID'];
};

export type ReportPreAdmissionVideoProgressPayload = {
  __typename?: 'ReportPreAdmissionVideoProgressPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<ReportPreAdmissionVideoProgressResult>;
};

export type ReportPreAdmissionVideoProgressResult = {
  __typename?: 'ReportPreAdmissionVideoProgressResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type RequestAppointment = {
  __typename?: 'RequestAppointment';
  appointmentType: RequestAppointmentType;
  confirmedAppointmentStartAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  facilityId: Scalars['Int'];
  facilityMenu: RequestAppointmentFacilityMenu;
  id: Scalars['ID'];
  latestFacilityProposedDates: Maybe<Array<RequestAppointmentFacilityProposedDate>>;
  patientReplyDeadlineAt: Maybe<Scalars['DateTime']>;
  personId: Scalars['ID'];
  requestedAppointmentDateTimeSlots: Array<RequestedAppointmentDateTimeSlot>;
  status: RequestAppointmentStatus;
  updatedAt: Scalars['DateTime'];
};

export type RequestAppointmentCard = {
  __typename?: 'RequestAppointmentCard';
  requestAppointment: RequestAppointment;
  requestAppointmentCardContext: RequestAppointmentCardContext;
};

export type RequestAppointmentCardContext = {
  __typename?: 'RequestAppointmentCardContext';
  outpatientContactUrl: Scalars['String'];
};

export type RequestAppointmentConsultationInput = {
  detail?: InputMaybe<Scalars['String']>;
  diseaseOrSymptom: Scalars['String'];
};

export type RequestAppointmentEnableStatusEnum =
  | 'DISABLED'
  | 'ENABLED'
  | 'NEW_REQUEST_DISABLED';

export type RequestAppointmentFacility = {
  __typename?: 'RequestAppointmentFacility';
  id: Scalars['Int'];
  menus: Array<RequestAppointmentFacilityMenu>;
  name: Scalars['String'];
  setting: RequestAppointmentFacilitySetting;
};

export type RequestAppointmentFacilityMenu = {
  __typename?: 'RequestAppointmentFacilityMenu';
  category: RequestAppointmentMenuCategory;
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  menuType: RequestAppointmentMenuType;
  name: Scalars['String'];
};

export type RequestAppointmentFacilityProposedDate = {
  __typename?: 'RequestAppointmentFacilityProposedDate';
  id: Scalars['ID'];
  proposedAppointmentStartAt: Scalars['DateTime'];
  result: RequestAppointmentProposedDateResult;
};

export type RequestAppointmentFacilitySetting = {
  __typename?: 'RequestAppointmentFacilitySetting';
  descriptions: Array<RequestAppointmentFacilitySettingDescription>;
  facilityReplyDeadlineDays: Scalars['Int'];
  leadTimeMaxDate: Scalars['String'];
  leadTimeMinDate: Scalars['String'];
  noReferralFeeDescription: Scalars['String'];
  outpatientContactUrl: Scalars['String'];
  outpatientScheduleDescription: Scalars['String'];
  outpatientScheduleUrl: Scalars['String'];
  patientIdMaxLength: Scalars['Int'];
  patientIdMinLength: Scalars['Int'];
  patientReplyDeadlineDays: Scalars['Int'];
};

export type RequestAppointmentFacilitySettingDescription = {
  __typename?: 'RequestAppointmentFacilitySettingDescription';
  body: Scalars['String'];
  displayOrder: Scalars['Int'];
  title: Scalars['String'];
};

export type RequestAppointmentMenuCategory =
  | 'CHECKUP'
  | 'DEPARTMENT'
  | 'EXAMINATION'
  | 'VACCINATION';

export type RequestAppointmentMenuType =
  | 'REQUEST_APPOINTMENT'
  | 'TELEPHONE';

export type RequestAppointmentPatientCard = {
  __typename?: 'RequestAppointmentPatientCard';
  patientId: Maybe<Scalars['String']>;
  status: RequestAppointmentPatientCardStatus;
};

export type RequestAppointmentPatientCardInput = {
  patientId?: InputMaybe<Scalars['String']>;
  status: RequestAppointmentPatientCardStatus;
};

export type RequestAppointmentPatientCardStatus =
  | 'ACTIVE'
  | 'NONE'
  | 'UNKNOWN';

export type RequestAppointmentPersonalInformation = {
  __typename?: 'RequestAppointmentPersonalInformation';
  addressLine1: Scalars['String'];
  addressLine2: Maybe<Scalars['String']>;
  birthday: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  nameFirst: Scalars['String'];
  nameFirstKana: Scalars['String'];
  nameLast: Scalars['String'];
  nameLastKana: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  prefecture: Scalars['String'];
  sex: Sex;
};

export type RequestAppointmentPersonalInformationInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  birthday: BirthdayInput;
  city: Scalars['String'];
  email: Scalars['String'];
  nameFirst: Scalars['String'];
  nameFirstKana: Scalars['String'];
  nameLast: Scalars['String'];
  nameLastKana: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  prefecture: Scalars['String'];
  sex: Sex;
};

export type RequestAppointmentPresets = {
  __typename?: 'RequestAppointmentPresets';
  patientCard: Maybe<RequestAppointmentPatientCard>;
  personalInformation: Maybe<RequestAppointmentPersonalInformation>;
};

export type RequestAppointmentProposedDateResult =
  | 'NG'
  | 'OK'
  | 'WAIT';

export type RequestAppointmentProposedDateResultInput = {
  facilityProposedDateId: Scalars['ID'];
  result: RequestAppointmentProposedDateResultInputEnum;
};

export type RequestAppointmentProposedDateResultInputEnum =
  | 'NG'
  | 'OK';

export type RequestAppointmentReferralInput = {
  departmentName?: InputMaybe<Scalars['String']>;
  doctorName?: InputMaybe<Scalars['String']>;
  facilityName: Scalars['String'];
  facilityTelephoneNumber?: InputMaybe<Scalars['String']>;
};

export type RequestAppointmentStatus =
  | 'CANCELED'
  | 'CONFIRMED'
  | 'PENDING_FACILITY_RESPONSE'
  | 'PENDING_PATIENT_RESPONSE';

export type RequestAppointmentType =
  | 'NEW'
  | 'RESCHEDULE';

export type RequestedAppointmentDateTimeSlot = {
  __typename?: 'RequestedAppointmentDateTimeSlot';
  requestAppointmentEarliestAt: Scalars['DateTime'];
  requestAppointmentLatestAt: Scalars['DateTime'];
};

export type RequestedAppointmentDateTimeSlotInput = {
  requestAppointmentEarliestAt: Scalars['DateTime'];
  requestAppointmentLatestAt: Scalars['DateTime'];
};

export type RequestedVisitDate = {
  ampm: Ampm;
  date: DateWithoutTime;
};

export type ReservationAcceptableSlots = {
  __typename?: 'ReservationAcceptableSlots';
  fridayAm: Scalars['Boolean'];
  fridayPm: Scalars['Boolean'];
  mondayAm: Scalars['Boolean'];
  mondayPm: Scalars['Boolean'];
  saturdayAm: Scalars['Boolean'];
  saturdayPm: Scalars['Boolean'];
  sundayAm: Scalars['Boolean'];
  sundayPm: Scalars['Boolean'];
  thursdayAm: Scalars['Boolean'];
  thursdayPm: Scalars['Boolean'];
  tuesdayAm: Scalars['Boolean'];
  tuesdayPm: Scalars['Boolean'];
  wednesdayAm: Scalars['Boolean'];
  wednesdayPm: Scalars['Boolean'];
};

export type ReservationPreference = {
  __typename?: 'ReservationPreference';
  acceptableSlots: ReservationAcceptableSlots;
  isEnabled: Scalars['Boolean'];
  reservationNotice: Scalars['String'];
};

export type ReturnVisitDetail =
  | 'RETURN_VISIT_NEW'
  | 'RETURN_VISIT_OTHER'
  | 'RETURN_VISIT_ROUTINE';

export type SendPharmacyBookingEmailOtpError = PharmacyBookingConsentUnavailableError | PharmacyBookingEmailVerificationInvalidEmailError | PharmacyBookingEmailVerificationRateLimitedError;

export type SendPharmacyBookingEmailOtpInput = {
  /** 確認するメールアドレス */
  email: Scalars['String'];
  personId: Scalars['ID'];
};

export type SendPharmacyBookingEmailOtpPayload = {
  __typename?: 'SendPharmacyBookingEmailOtpPayload';
  /** 確認コード ID（検証時に使用） */
  emailVerificationId: Maybe<Scalars['ID']>;
  errors: Array<SendPharmacyBookingEmailOtpError>;
};

export type SendVisitMemoError = CheckInNotFoundError | LinkageNotFoundError;

/** 受診メモ送信の入力（暫定 consumer 経路） */
export type SendVisitMemoInput = {
  /** 🏥 通院中の病気 / 主訴 */
  currentSymptoms: Array<Scalars['String']>;
  /** 医療機関 ID（病院連携サブルーチンで解決済みの facility_id） */
  facilityId: Scalars['Int'];
  /** 🧐 気になっていること */
  interests: Array<Scalars['String']>;
  /** 🏠 生活習慣 */
  lifestyle: Array<Scalars['String']>;
  /** 💊 服薬状況（自院含めた） */
  medicationAdherence: Array<Scalars['String']>;
  /** 💊 他院での服薬・サプリ */
  medications: Array<Scalars['String']>;
  /** 受診メモ作成日時（= coedo.consultation_summaries.createdAt） */
  occurredAt: Scalars['DateTime'];
  /** 📦 その他 */
  other: Array<Scalars['String']>;
  /** 連携元の受診メモ ID（= coedo.consultation_summaries.id）。冪等キー。 */
  rawRecordId: Scalars['ID'];
};

export type SendVisitMemoPayload = {
  __typename?: 'SendVisitMemoPayload';
  /** ドメインエラー（回復可能。空配列なら成功）。 */
  errors: Array<SendVisitMemoError>;
  /** 作成（または上書き）された MIS 側の受診メモ。errors がある場合は null。 */
  visitMemo: Maybe<VisitMemo>;
};

export type SessionQuestionNotFoundError = Error & {
  __typename?: 'SessionQuestionNotFoundError';
  message: Scalars['String'];
};

export type Sex =
  | 'FEMALE'
  | 'MALE';

export type StartPreAdmissionInquiryError = AnonymousAccountError | ConsentNotGivenError | MedicalInstitutionNotLinkedError | PatientIdNotLinkedError | PreAdmissionInquiryNotFoundError;

export type StartPreAdmissionInquiryInput = {
  personId: Scalars['ID'];
  preAdmissionInquiryId: Scalars['ID'];
};

export type StartPreAdmissionInquiryPayload = {
  __typename?: 'StartPreAdmissionInquiryPayload';
  errors: Array<StartPreAdmissionInquiryError>;
  result: Maybe<StartPreAdmissionInquiryResult>;
};

export type StartPreAdmissionInquiryResult = {
  __typename?: 'StartPreAdmissionInquiryResult';
  /** 画像アップロード用 mutation で必要な askman セッション ID */
  askmanSessionId: Scalars['ID'];
  progress: AskmanSessionProgress;
  /** 最初の質問。質問がない場合は null */
  sessionQuestion: Maybe<AskmanSessionQuestion>;
};

export type StartPreAdmissionVideoPdfViewingInput = {
  /** 配信元の医療機関 ID。患者を一意に特定するために必須 */
  facilityId: Scalars['Int'];
  /** 配信内の動画 1 件の ID。PDF は動画に付随するため動画と同じ ID で指定する */
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  /** 入院前の動画配信 ID（配信単位） */
  preAdmissionVideoId: Scalars['ID'];
};

export type StartPreAdmissionVideoPdfViewingPayload = {
  __typename?: 'StartPreAdmissionVideoPdfViewingPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<StartPreAdmissionVideoPdfViewingResult>;
};

export type StartPreAdmissionVideoPdfViewingResult = {
  __typename?: 'StartPreAdmissionVideoPdfViewingResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type StartPreAdmissionVideoViewingInput = {
  /** 配信元の医療機関 ID。患者を一意に特定するために必須 */
  facilityId: Scalars['Int'];
  /** 配信内の動画 1 件の ID */
  mediaDeliveryVideoItemId: Scalars['ID'];
  personId: Scalars['ID'];
  /** 入院前の動画配信 ID（配信単位） */
  preAdmissionVideoId: Scalars['ID'];
};

export type StartPreAdmissionVideoViewingPayload = {
  __typename?: 'StartPreAdmissionVideoViewingPayload';
  errors: Array<PreAdmissionVideoError>;
  result: Maybe<StartPreAdmissionVideoViewingResult>;
};

export type StartPreAdmissionVideoViewingResult = {
  __typename?: 'StartPreAdmissionVideoViewingResult';
  deliveryVideoItem: MediaDeliveryVideoItem;
};

export type UnlinkFromMedicalInstitutionInput = {
  linkCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type UnlinkFromMedicalInstitutionPayload = {
  __typename?: 'UnlinkFromMedicalInstitutionPayload';
  success: Scalars['Boolean'];
};

/**
 * 本人確認情報が一致しなかった（残り試行回数あり）。
 * 生年月日等の再入力を促す。
 */
export type VerificationFailedError = Error & {
  __typename?: 'VerificationFailedError';
  message: Scalars['String'];
};

export type VerifyOtpCodeError = EmailVerificationAttemptsExceededError | EmailVerificationExpiredError | EmailVerificationInvalidCodeError;

export type VerifyOtpCodeInput = {
  code: Scalars['String'];
  otpId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type VerifyOtpCodePayload = {
  __typename?: 'VerifyOtpCodePayload';
  errors: Array<VerifyOtpCodeError>;
  verificationToken: Maybe<Scalars['String']>;
};

export type VerifyPharmacyBookingEmailOtpError = PharmacyBookingEmailVerificationInvalidError | PharmacyBookingEmailVerificationUnavailableError;

export type VerifyPharmacyBookingEmailOtpInput = {
  /** 確認コード ID（sendPharmacyBookingEmailOtp で取得） */
  emailVerificationId: Scalars['ID'];
  /** 確認コード（6桁） */
  otpCode: Scalars['String'];
  personId: Scalars['ID'];
};

export type VerifyPharmacyBookingEmailOtpPayload = {
  __typename?: 'VerifyPharmacyBookingEmailOtpPayload';
  errors: Array<VerifyPharmacyBookingEmailOtpError>;
  /** 確認トークン（予約登録時に使用） */
  verificationToken: Maybe<Scalars['String']>;
};

/** MIS 側に保管された受診メモ（consultation_summaries） */
export type VisitMemo = {
  __typename?: 'VisitMemo';
  id: Scalars['ID'];
};

export type VisitType =
  | 'FIRST_VISIT'
  | 'RETURN_VISIT';

export type MedicalInstitutionInformationCardFragment = { __typename?: 'MedicoFacility', address: string | null, telephoneNumber: string | null, telephoneReceptionNote: string | null, amOpenTime: string | null, amCloseTime: string | null, pmOpenTime: string | null, pmCloseTime: string | null, closeDays: string | null, characteristic: string | null } & { ' $fragmentName'?: 'MedicalInstitutionInformationCardFragment' };

export type MedicalInstitutionTopFragment = (
  { __typename?: 'MedicoFacility', name: string, guidance: string | null }
  & { ' $fragmentRefs'?: { 'MedicalInstitutionInformationCardFragment': MedicalInstitutionInformationCardFragment } }
) & { ' $fragmentName'?: 'MedicalInstitutionTopFragment' };

export type MedicalInstitutionForAppointmentFragment = { __typename?: 'MedicalInstitution', id: string, name: string, latitude: number, longitude: number, address: string, abbreviatedName: string, transportation: string | null, nearestStation: string | null, timeFromStation: string | null, availableElectronicPrescription: boolean, availableMyNumberCardAsHealthInsuranceCards: boolean, supportedCreditCards: Array<string>, supportedForeignLanguages: Array<string>, isSecondOpinionAcceptable: boolean | null, isSecondOpinionReferralOfferable: boolean | null, isFeverOutpatientAcceptable: boolean | null, freeParkingLotCapacity: number | null, freeParkingLotCapacityForDisabled: number | null, phoneNumber: string | null, websiteUrl: string | null, openingHourTextAm: string | null, openingHourTextPm: string | null, closedDays: string | null, openingHours: Array<{ __typename?: 'MedicalInstitutionOpeningHour', dayOfWeek: DayOfWeek, closeTime: string }>, clinicalDepartments: Array<{ __typename?: 'MedicalInstitutionClinicalDepartment', id: number, name: string }>, medicalSpecialists: Array<{ __typename?: 'MedicalInstitutionMedicalSpecialist', medicalSpecialistNumberText: string | null, medicalSpecialist: { __typename?: 'MedicalSpecialist', id: number, name: string } }>, medicoHospital: { __typename?: 'MedicoHospital', hospitalUserId: number | null, isUbielinkEnabled: boolean, address: string | null, amOpenTime: string | null, pmOpenTime: string | null, amCloseTime: string | null, pmCloseTime: string | null, mainImageUrl: string | null, subImageUrl1: string | null, subImageUrl2: string | null, closeDays: string | null, websiteUrl: string | null, telephoneNumber: string | null, isHolidayOpeningLabelEnabled: boolean, isLateCloseTimeLabelEnabled: boolean, clinicalDepartments: Array<{ __typename?: 'ClinicalDepartment', id: number, name: string }> } | null, reservationPreference: { __typename?: 'ReservationPreference', isEnabled: boolean, reservationNotice: string, acceptableSlots: { __typename?: 'ReservationAcceptableSlots', mondayAm: boolean, mondayPm: boolean, tuesdayAm: boolean, tuesdayPm: boolean, wednesdayAm: boolean, wednesdayPm: boolean, thursdayAm: boolean, thursdayPm: boolean, fridayAm: boolean, fridayPm: boolean, saturdayAm: boolean, saturdayPm: boolean, sundayAm: boolean, sundayPm: boolean } }, experimentalSetting: { __typename?: 'ExperimentalSetting', closedDays: Array<string>, requestBooking: boolean, menus: Array<{ __typename?: 'ExperimentalSettingMenu', name: string, flow: ExperimentalSettingFlow, note: string | null }> } | null } & { ' $fragmentName'?: 'MedicalInstitutionForAppointmentFragment' };

export type MakeAppointmentMutationVariables = Exact<{
  input: MakeAppointmentInput;
}>;


export type MakeAppointmentMutation = { __typename?: 'Mutation', makeAppointment: { __typename?: 'MakeAppointmentPayload', result: boolean } };

export type FindMedicalInstitutionWithReservationPreferenceByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FindMedicalInstitutionWithReservationPreferenceByIdQuery = { __typename?: 'Query', medicalInstitution: (
    { __typename?: 'MedicalInstitution' }
    & { ' $fragmentRefs'?: { 'MedicalInstitutionForAppointmentFragment': MedicalInstitutionForAppointmentFragment } }
  ) | null };

export type MedicalInstitutionTopByIdQueryVariables = Exact<{
  facilityMemberId: Scalars['Int'];
}>;


export type MedicalInstitutionTopByIdQuery = { __typename?: 'Query', medicoFacilityByFacilityMemberId: (
    { __typename?: 'MedicoFacility', id: string }
    & { ' $fragmentRefs'?: { 'MedicalInstitutionTopFragment': MedicalInstitutionTopFragment } }
  ) | null };

export type MedicalInstitutionTopByKeyQueryVariables = Exact<{
  facilityMemberKey: Scalars['String'];
}>;


export type MedicalInstitutionTopByKeyQuery = { __typename?: 'Query', medicoFacilityByFacilityMemberKey: (
    { __typename?: 'MedicoFacility', id: string }
    & { ' $fragmentRefs'?: { 'MedicalInstitutionTopFragment': MedicalInstitutionTopFragment } }
  ) | null };

export type SignupView_MedicoFacilityFragment = { __typename?: 'MedicoFacility', isSignInSkippableForSmartphoneMonshin: boolean } & { ' $fragmentName'?: 'SignupView_MedicoFacilityFragment' };

export type MediaDeliveryPublicVideoByTokenQueryVariables = Exact<{
  facilityId: Scalars['Int'];
  token: Scalars['String'];
  videoId: Scalars['ID'];
}>;


export type MediaDeliveryPublicVideoByTokenQuery = { __typename?: 'Query', mediaDeliveryPublicVideoByToken: { __typename?: 'MediaDeliveryPublicVideo', id: string, title: string, description: string | null, facility: { __typename?: 'Facility', name: string }, thumbnail: { __typename?: 'MediaDeliverySignedUrl', url: string }, stream: { __typename?: 'MediaDeliveryVideoStream', url: string }, pdf: { __typename?: 'MediaDeliverySignedUrl', url: string } | null } | null };

export type MediaDeliveryPublicVideoPackageByTokenQueryVariables = Exact<{
  facilityId: Scalars['Int'];
  token: Scalars['String'];
}>;


export type MediaDeliveryPublicVideoPackageByTokenQuery = { __typename?: 'Query', mediaDeliveryPublicVideoPackageByToken: { __typename?: 'MediaDeliveryPublicVideoPackage', title: string, description: string | null, facility: { __typename?: 'Facility', name: string }, videos: Array<{ __typename?: 'MediaDeliveryPublicVideo', id: string, title: string, description: string | null, durationSeconds: number | null, thumbnail: { __typename?: 'MediaDeliverySignedUrl', url: string } }> } | null };

export type MonshinSignupQueryVariables = Exact<{
  keyOrId: Scalars['String'];
}>;


export type MonshinSignupQuery = { __typename?: 'Query', medicoFacilityByKeyOrId: (
    { __typename?: 'MedicoFacility', id: string }
    & { ' $fragmentRefs'?: { 'SignupView_MedicoFacilityFragment': SignupView_MedicoFacilityFragment } }
  ) | null };

export type RedirectTokenByTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type RedirectTokenByTokenQuery = { __typename?: 'Query', redirectTokenByToken: { __typename?: 'RedirectToken', redirectUrl: string, purpose: string } | null };

export const MedicalInstitutionInformationCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MedicalInstitutionInformationCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MedicoFacility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneReceptionNote"}},{"kind":"Field","name":{"kind":"Name","value":"amOpenTime"}},{"kind":"Field","name":{"kind":"Name","value":"amCloseTime"}},{"kind":"Field","name":{"kind":"Name","value":"pmOpenTime"}},{"kind":"Field","name":{"kind":"Name","value":"pmCloseTime"}},{"kind":"Field","name":{"kind":"Name","value":"closeDays"}},{"kind":"Field","name":{"kind":"Name","value":"characteristic"}}]}}]} as unknown as DocumentNode<MedicalInstitutionInformationCardFragment, unknown>;
export const MedicalInstitutionTopFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MedicalInstitutionTop"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MedicoFacility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"guidance"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MedicalInstitutionInformationCard"}}]}}]} as unknown as DocumentNode<MedicalInstitutionTopFragment, unknown>;
export const MedicalInstitutionForAppointmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MedicalInstitutionForAppointment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MedicalInstitution"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviatedName"}},{"kind":"Field","name":{"kind":"Name","value":"transportation"}},{"kind":"Field","name":{"kind":"Name","value":"nearestStation"}},{"kind":"Field","name":{"kind":"Name","value":"timeFromStation"}},{"kind":"Field","name":{"kind":"Name","value":"availableElectronicPrescription"}},{"kind":"Field","name":{"kind":"Name","value":"availableMyNumberCardAsHealthInsuranceCards"}},{"kind":"Field","name":{"kind":"Name","value":"supportedCreditCards"}},{"kind":"Field","name":{"kind":"Name","value":"supportedForeignLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"isSecondOpinionAcceptable"}},{"kind":"Field","name":{"kind":"Name","value":"isSecondOpinionReferralOfferable"}},{"kind":"Field","name":{"kind":"Name","value":"isFeverOutpatientAcceptable"}},{"kind":"Field","name":{"kind":"Name","value":"freeParkingLotCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"freeParkingLotCapacityForDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"openingHourTextAm"}},{"kind":"Field","name":{"kind":"Name","value":"openingHourTextPm"}},{"kind":"Field","name":{"kind":"Name","value":"closedDays"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"closeTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clinicalDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medicalSpecialists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicalSpecialist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medicalSpecialistNumberText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medicoHospital"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hospitalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"isUbielinkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"amOpenTime"}},{"kind":"Field","name":{"kind":"Name","value":"pmOpenTime"}},{"kind":"Field","name":{"kind":"Name","value":"amCloseTime"}},{"kind":"Field","name":{"kind":"Name","value":"pmCloseTime"}},{"kind":"Field","name":{"kind":"Name","value":"mainImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subImageUrl1"}},{"kind":"Field","name":{"kind":"Name","value":"subImageUrl2"}},{"kind":"Field","name":{"kind":"Name","value":"closeDays"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isHolidayOpeningLabelEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isLateCloseTimeLabelEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNotice"}},{"kind":"Field","name":{"kind":"Name","value":"acceptableSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mondayAm"}},{"kind":"Field","name":{"kind":"Name","value":"mondayPm"}},{"kind":"Field","name":{"kind":"Name","value":"tuesdayAm"}},{"kind":"Field","name":{"kind":"Name","value":"tuesdayPm"}},{"kind":"Field","name":{"kind":"Name","value":"wednesdayAm"}},{"kind":"Field","name":{"kind":"Name","value":"wednesdayPm"}},{"kind":"Field","name":{"kind":"Name","value":"thursdayAm"}},{"kind":"Field","name":{"kind":"Name","value":"thursdayPm"}},{"kind":"Field","name":{"kind":"Name","value":"fridayAm"}},{"kind":"Field","name":{"kind":"Name","value":"fridayPm"}},{"kind":"Field","name":{"kind":"Name","value":"saturdayAm"}},{"kind":"Field","name":{"kind":"Name","value":"saturdayPm"}},{"kind":"Field","name":{"kind":"Name","value":"sundayAm"}},{"kind":"Field","name":{"kind":"Name","value":"sundayPm"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experimentalSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closedDays"}},{"kind":"Field","name":{"kind":"Name","value":"requestBooking"}},{"kind":"Field","name":{"kind":"Name","value":"menus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]}}]} as unknown as DocumentNode<MedicalInstitutionForAppointmentFragment, unknown>;
export const SignupView_MedicoFacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignupView_MedicoFacility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MedicoFacility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSignInSkippableForSmartphoneMonshin"}}]}}]} as unknown as DocumentNode<SignupView_MedicoFacilityFragment, unknown>;
export const MakeAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"makeAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MakeAppointmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeAppointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<MakeAppointmentMutation, MakeAppointmentMutationVariables>;
export const FindMedicalInstitutionWithReservationPreferenceByIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findMedicalInstitutionWithReservationPreferenceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicalInstitution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MedicalInstitutionForAppointment"}}]}}]}},...MedicalInstitutionForAppointmentFragmentDoc.definitions]} as unknown as DocumentNode<FindMedicalInstitutionWithReservationPreferenceByIdQuery, FindMedicalInstitutionWithReservationPreferenceByIdQueryVariables>;
export const MedicalInstitutionTopByIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"medicalInstitutionTopById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityMemberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicoFacilityByFacilityMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityMemberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityMemberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MedicalInstitutionTop"}}]}}]}},...MedicalInstitutionTopFragmentDoc.definitions,...MedicalInstitutionInformationCardFragmentDoc.definitions]} as unknown as DocumentNode<MedicalInstitutionTopByIdQuery, MedicalInstitutionTopByIdQueryVariables>;
export const MedicalInstitutionTopByKeyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"medicalInstitutionTopByKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityMemberKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicoFacilityByFacilityMemberKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityMemberKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityMemberKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MedicalInstitutionTop"}}]}}]}},...MedicalInstitutionTopFragmentDoc.definitions,...MedicalInstitutionInformationCardFragmentDoc.definitions]} as unknown as DocumentNode<MedicalInstitutionTopByKeyQuery, MedicalInstitutionTopByKeyQueryVariables>;
export const MediaDeliveryPublicVideoByTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"mediaDeliveryPublicVideoByToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaDeliveryPublicVideoByToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<MediaDeliveryPublicVideoByTokenQuery, MediaDeliveryPublicVideoByTokenQueryVariables>;
export const MediaDeliveryPublicVideoPackageByTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"mediaDeliveryPublicVideoPackageByToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaDeliveryPublicVideoPackageByToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MediaDeliveryPublicVideoPackageByTokenQuery, MediaDeliveryPublicVideoPackageByTokenQueryVariables>;
export const MonshinSignupDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"monshinSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyOrId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicoFacilityByKeyOrId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keyOrId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyOrId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignupView_MedicoFacility"}}]}}]}},...SignupView_MedicoFacilityFragmentDoc.definitions]} as unknown as DocumentNode<MonshinSignupQuery, MonshinSignupQueryVariables>;
export const RedirectTokenByTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redirectTokenByToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectTokenByToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}}]}}]}}]} as unknown as DocumentNode<RedirectTokenByTokenQuery, RedirectTokenByTokenQueryVariables>;